import { u as N, _ as B, ab as Ve, T as f, ag as Ye, ah as de, ai as Ct, z as he, a7 as Je, a2 as wt, J as jt, A as It, B as vt, G as Tt, I as kt, K as Q, a8 as Mt, X as At, Y as Be, a3 as qt, a4 as Ft, a5 as Dt, a0 as Xe, aj as Rt, aa as Et, v as Ue, ac as Pt, a6 as Ot, a9 as Lt, ad as Nt, ae as Wt, o as Gt, n as zt, p as Bt, ak as Ut, al as Ht, am as Kt, an as $t } from "./eMyAsurionProvider-ec3ed988.js";
import { f as lr, at as dr, i as ur, c as hr, j as pr, C as xr, D as gr, H as mr, L as br, M as fr, a as yr, b as Sr, m as Cr, e as wr, N as jr, l as Ir, P as vr, k as Tr, F as kr, R as Mr, h as Ar, S as qr, au as Fr, V as Dr, d as Rr, g as Er, ao as Pr, af as Or, ap as Lr, aq as Nr, as as Wr, ar as Gr } from "./eMyAsurionProvider-ec3ed988.js";
import { AvatarInitials as Br } from "./myasurion-shared.profile.es.js";
import { P as Hr } from "./ProtectedLayout-0ed12e03.js";
import { B as $r, S as _r } from "./SubHeader-d125f397.js";
import { I as Vr, T as Yr } from "./Input-00e9b741.js";
import { Faq as Xr } from "./myasurion-shared.efaq.es.js";
import { D as ea } from "./DeviceCard-bb567dd4.js";
import { HelloWorld as oa } from "./myasurion-shared.message.es.js";
import { T as sa } from "./TextTranslation-958db347.js";
import { D as aa } from "./DeviceService-7cb1b3a0.js";
import { SubmitRequest as ca } from "./myasurion-shared.esubmitRequest.es.js";
import { ReviewSubmission as da } from "./myasurion-shared.ereviewSubmission.es.js";
import { PaymentForm as ha } from "./myasurion-shared.payment.es.js";
import { TermsAndCondition as xa } from "./myasurion-shared.T_C.es.js";
import { C as ma } from "./Cards-2370a0d0.js";
import { S as fa } from "./SmartStock-ac07910f.js";
import { D as Sa } from "./DeviceSelection-de123304.js";
import { D as wa } from "./DeliveryOptions-89f4f5f1.js";
import { D as Ia, L as va, P as Ta, S as ka } from "./PickupSchedule-4988fbbf.js";
import { Button as Aa } from "./myasurion-shared.widgets.es.js";
import { D as Fa } from "./DeviceModel-b18d4b7b.js";
import { S as Ra } from "./SubmitDeclaration-95b3310f.js";
import { TriageQuestion as Pa } from "./myasurion-shared.Triage.es.js";
import { NPSSlider as La } from "./NPSSlider-1271fee7.js";
import { NPSReasons as Wa } from "./NPSReasons-164ff607.js";
import { j as e } from "./react-944c88e2.js";
import { useDisclosure as _t, useBoolean as Qt, Flex as M, Box as k, Image as ue, Text as v, Button as V, VStack as Ie, Textarea as Ze, SimpleGrid as Le, Center as se, Spinner as et, CheckboxGroup as Vt, Stack as Yt, Checkbox as Jt, Slider as Xt, SliderMark as Zt, SliderTrack as eo, SliderFilledTrack as to, SliderThumb as oo, IconButton as no, useMediaQuery as so } from "@chakra-ui/react";
import { ArrowBackIcon as ro, MinusIcon as ao, CloseIcon as tt, ArrowLeftIcon as io } from "@chakra-ui/icons";
import { A as za, B as Ba, C as Ua, c as Ha, a as Ka, I as $a, M as _a, R as Qa, S as Va, b as Ya, U as Ja } from "./Creditcard-54ffaeaa.js";
import { V as Za } from "./ViewDocument-a8f2f711.js";
import { C as ti, u as oi } from "./providers-e896aa48.js";
import { G as si, O as ri, S as ai } from "./GoogleSignInButton-b48c78b4.js";
import { T as ci } from "./TextEditIcon-a2966440.js";
import { C as di, a as ui, L as hi, P as pi } from "./LockIcon-3715d1f2.js";
import { P as gi } from "./PaymentCCIcon-ee4f339b.js";
import { T as bi, q as fi } from "./ThemeProvider-a28b07b1.js";
import { u as Ne, m as We } from "./useAccount-8a1c7225.js";
import { b as Si, e as Ci, d as wi, g as ji, a as Ii, j as vi, f as Ti, l as ki, h as Mi, i as Ai, n as qi, c as Fi, p as Di, k as Ri, t as Ei } from "./useAccount-8a1c7225.js";
import { useAgreementData as Oi, useCognitoAuth as Li, useContentfulEntry as Ni, useDarkMode as Wi, useDetermineIncidentData as Gi, useDocumentTitle as zi, useElementSize as Bi, useImageOnLoad as Ui, useInitializeData as Hi, useInteractionData as Ki, useIntersectionObserver as $i, useInterval as _i, useIsFirstRender as Qi, useIsMounted as Vi, useLocalStorage as Yi, useMediaQuery as Ji, useReadLocalStorage as Xi, useScreen as Zi, useTimeout as ec, useToggle as tc, useWindowSize as oc } from "./myasurion-shared.hooks.es.js";
import { u as sc } from "./useFetchConfig-fab2804f.js";
import { usePublish as ac, useSubscribe as ic } from "./myasurion-shared.modules.es.js";
import { a as me } from "./domains-162ab8d8.js";
import { f as lc, e as dc, b as uc, d as hc, m as pc, n as xc, j as gc, i as mc, h as bc, g as fc, c as yc, l as Sc, k as Cc } from "./domains-162ab8d8.js";
import { getCountryByCarrier as jc, getDefaultLanguageByCarrier as Ic } from "./myasurion-shared.carrier.es.js";
import { F as Tc, u as kc } from "./features-4c20b5b5.js";
import { ChatButton as Ac } from "./myasurion-shared.echat.es.js";
import * as je from "react";
import { createContext as pe, useState as q, useMemo as re, useContext as xe, useEffect as ee, useCallback as co, useRef as ot } from "react";
import "./firebase-d0134a8f.js";
import "./@firebase-868b0e52.js";
import "./node-forge-b3503c74.js";
import { b as nt } from "./usehooks-ts-53aa4768.js";
import { Mixpanel as Fc } from "./myasurion-shared.mixpanel.es.js";
import { c as Pe } from "./contentful-ed636ee7.js";
import { b as Rc, a as Ec, g as Pc, p as Oc } from "./contentful-ed636ee7.js";
import { useQuery as De, useQueryClient as st } from "@tanstack/react-query";
import { delay as z } from "framer-motion";
import { s as lo } from "./sanitize-html-56ac9e65.js";
import "./contentful-a9b11b75.js";
import "react-router-dom";
import "./crypto-js-1bed509f.js";
import "./process-481e9afe.js";
import "./cleave.js-cf58c059.js";
import "./colornames-7577e860.js";
import "./file-saver-1aff1f79.js";
import "@react-oauth/google";
import { C as O, d as K, u as qe, a as uo, b as Fe, c as He } from "./useSubscribe-2e7c57a8.js";
import { r as Ge } from "./sessionstorage-42deb565.js";
import { u as ho, F as $, V as rt, T as G, e as po, B as H, I as Ke, A as xo, a as go, b as mo, c as bo, d as fo, j as yo } from "./@chakra-ui-f377b543.js";
import { u as So } from "./useContentfulEntryComplete-f9beccef.js";
import { g as Co } from "./constants-261954cc.js";
import { S as wo } from "./SendMessage-c92bdf4d.js";
import { MyAsurionDevTools as Nc } from "./myasurion-shared.devtools.es.js";
import { getChakraColorScale as Gc, getColorsList as zc, hexToNumber as Bc, isValidHex as Uc } from "./myasurion-shared.colors.es.js";
import "./axios-d6123f02.js";
import "./typescript-collections-b97a1d6d.js";
import "./@contentful-cca97bae.js";
import "./moment-a2f61e40.js";
import "./browser-detect-b0c87b70.js";
import "./@aws-amplify-21547700.js";
import "./js-cookie-d54fed8f.js";
import "./@aws-crypto-5d5961ee.js";
import "./tslib-1406810b.js";
import "./@smithy-2331ff76.js";
import "./rxjs-c3576f66.js";
import "./uuid-5adc31c9.js";
import "./aws-amplify-2a9a372d.js";
import "./react-responsive-carousel-5d5a6886.js";
import "./react-easy-swipe-5c12dd2c.js";
import "./prop-types-5dc3ead4.js";
import "./react-is-fdabd8df.js";
import "./object-assign-d7a4d3b1.js";
import "./classnames-0d222af1.js";
import "./lodash-bd0366b5.js";
import "./xstate-03560826.js";
import "./@xstate-e6d7a3e3.js";
import "./use-sync-external-store-9c68af99.js";
import "./use-isomorphic-layout-effect-37cd9e90.js";
import "@emotion/react";
import "./formik-a668a7f5.js";
import "./deepmerge-c6c56555.js";
import "./lodash-es-9bce7d1a.js";
import "./tiny-warning-b49e0329.js";
import "./hoist-non-react-statics-0f4f9040.js";
import "./yup-c645f9e0.js";
import "./property-expr-5b4294d4.js";
import "./tiny-case-47ef5535.js";
import "./toposort-f63cd5fa.js";
import "./date-fns-9d457cca.js";
import "./@babel-dad84d6f.js";
import "./constants-de64d504.js";
import "./lodash.mergewith-9d927056.js";
import "./chakraReact-cc461a14.js";
import "./@zag-js-985153e8.js";
import "./react-fast-compare-e81d3847.js";
import "@emotion/styled";
import "./TextInput-b86fef07.js";
import "./index-d9fb9451.js";
import "./htmlparser2-114782f1.js";
import "./entities-09dd0ad3.js";
import "./domhandler-44c667b9.js";
import "./domelementtype-4b6931b4.js";
import "./domutils-84360663.js";
import "./dom-serializer-5c1f3d8a.js";
import "./escape-string-regexp-6e61e2c5.js";
import "./is-plain-object-c0b50e48.js";
import "./parse-srcset-ecafb4d2.js";
import "./postcss-68ef818a.js";
import "./picocolors-6ad9e134.js";
import "./nanoid-feb9a15b.js";
import "./react-best-gradient-color-picker-87da9ea7.js";
import "react-dom";
import "./tinycolor2-e04834eb.js";
import "./html2canvas-c76dc20e.js";
import "./use-immer-ae8601ab.js";
import "./immer-4e3ccba6.js";
import "./color-58d56877.js";
import "./color-string-43e78257.js";
import "./color-name-0faa9c28.js";
import "./simple-swizzle-41fe54f9.js";
import "./color-convert-15c02049.js";
const at = pe({
  isOpen: !1,
  toggleMinimize: () => {
  },
  onOpen: () => {
  },
  onClose: () => {
  },
  isMinimized: !1,
  hasChatsPending: !1,
  setHasChatsPending: () => {
  }
}), it = ({ children: o }) => {
  const { isOpen: i, onOpen: t, onClose: n } = _t(), [a, s] = Qt(), [d, r] = q(!1), c = () => {
    r(!1), s.toggle();
  }, l = () => {
    n(), r(!1);
  }, h = re(() => ({
    isOpen: i,
    onOpen: t,
    onClose: l,
    isMinimized: a,
    toggleMinimize: c,
    hasChatsPending: d,
    setHasChatsPending: r
  }), [i, t, l, a, c, d, r]);
  return /* @__PURE__ */ e.jsx(at.Provider, { value: h, children: o });
}, ae = () => xe(at), ct = ({
  containerStyles: o,
  indicatorStyles: i,
  buttonStyles: t
}) => {
  const { isMinimized: n, hasChatsPending: a, isOpen: s, toggleMinimize: d, onOpen: r } = ae(), { data: c } = N(), { theme: l } = c, {
    components: { chat: h }
  } = l, { chatConfig: u, firebaseConfig: x } = B(), { imageUrl: g } = Ve(
    h.agentIconSlug,
    u == null ? void 0 : u.contentful.space,
    u == null ? void 0 : u.contentful.token,
    u == null ? void 0 : u.contentful.env,
    x
  );
  return /* @__PURE__ */ e.jsxs(
    M,
    {
      css: {
        position: "fixed",
        bottom: 8,
        right: 8,
        zIndex: "1299",
        // Less than chakra drawer zIndex
        visibility: n || !s ? "visible" : "hidden"
      },
      sx: o,
      children: [
        a && /* @__PURE__ */ e.jsx(
          k,
          {
            css: {
              height: "15px",
              width: "15px",
              borderRadius: "100%",
              backgroundColor: "red",
              position: "fixed",
              bottom: 55,
              right: 45,
              zIndex: "1400",
              // Less than chakra drawer zIndex
              visibility: n || !s ? "visible" : "hidden",
              boxShadow: "0px 2px 3px 2px rgba(0, 0, 0, 0.08)"
            },
            sx: i
          }
        ),
        /* @__PURE__ */ e.jsx(
          ue,
          {
            role: "button",
            tabIndex: 0,
            className: "onboarding__chat",
            src: g ? Pe(g) : h.chatIcon,
            cursor: "pointer",
            onClick: n ? d : r,
            boxSize: "60px",
            alt: "Chat Widget",
            sx: t
          }
        )
      ]
    }
  );
}, ve = () => xe(mt), $e = [
  "Oops! Something went wrong. Let's give it another shot, shall we?",
  "We hit a bump in the digital highway. Ready to try that login again?",
  "Looks like our spaceship hit a meteor. Hit that login button and we'll soar again!"
], jo = () => {
  const { data: o } = N(), { theme: i } = o, {
    components: { chat: t }
  } = i, [, n] = Ne({ profileId: "", userId: "" }), [, a] = We({}), [s, d] = q(Math.floor(Math.random() * $e.length)), { isOpen: r, isMinimized: c } = ae(), l = (h = "") => {
    console.log("doLogout", h), localStorage.clear();
    const u = sessionStorage.getItem("p");
    sessionStorage.clear(), sessionStorage.setItem("p", u ?? ""), n({ profileId: "", userId: "" }), a({});
  };
  return r ? /* @__PURE__ */ e.jsx(
    M,
    {
      position: "fixed",
      w: { base: "full", lg: "350px" },
      h: { base: "full", xs: "800px" },
      mt: { base: "unset", lg: "30px" },
      top: "56px",
      bottom: { base: 0, lg: 8 },
      right: { base: 0, lg: 8 },
      zIndex: "20000",
      borderRadius: "lg",
      boxShadow: "lg",
      visibility: c ? "hidden" : "visible",
      bg: "white",
      children: /* @__PURE__ */ e.jsxs(
        M,
        {
          flexDirection: "column",
          textAlign: "center",
          className: "chatbot-node",
          alignItems: "center",
          justifyContent: "center",
          h: "full",
          w: "full",
          children: [
            /* @__PURE__ */ e.jsx(v, { mb: "30px", px: "20px", children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: $e[s],
                translationKey: `ReloginMessages/${s}`
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              V,
              {
                bgColor: t.secondary,
                color: t.onSecondary,
                my: 2,
                onClick: () => {
                  l("Relogin");
                },
                children: /* @__PURE__ */ e.jsx(
                  f,
                  {
                    text: "Try logging in again",
                    translationKey: "ReloginMessages/TryLoggingInAgain"
                  }
                )
              }
            )
          ]
        }
      )
    }
  ) : /* @__PURE__ */ e.jsx(e.Fragment, {});
}, Io = () => /* @__PURE__ */ e.jsxs(it, { children: [
  /* @__PURE__ */ e.jsx(jo, {}),
  /* @__PURE__ */ e.jsx(ct, {})
] }), lt = pe({
  userInfo: {
    name: "Visitor",
    mdn: "000000000",
    visitorId: "000000000",
    requestId: "000000000"
  },
  isFetchingAccountInfo: !0,
  isLoggedIn: !0,
  refetchUser: () => {
  }
}), vo = ({
  children: o,
  isLoggedIn: i
}) => {
  const { chatConfig: t } = B(), { configure: n } = Ye(), [a, s] = Ne({
    profileId: "",
    userId: "",
    requestId: "",
    visitorId: ""
  }), [d] = We({
    authorization: "",
    token: "",
    id: ""
  }), [r, c] = q({
    name: "Visitor",
    mdn: "",
    visitorId: "",
    requestId: ""
  }), { isLoading: l, refetch: h, isError: u } = De({
    queryKey: ["chatUserInfo", t, d.token],
    queryFn: n,
    cacheTime: 0,
    enabled: !!t && !!d.token,
    onSuccess: (p) => {
      const C = {
        ...a,
        requestId: p ? p.requestId : "",
        visitorId: p ? p.visitorId : ""
      };
      s(C), c(x(C));
    },
    onError: () => {
      const p = {
        ...a,
        requestId: "",
        visitorId: ""
      };
      s(p), c(x(p));
    }
  }), x = (p) => p != null && p.firstName || p != null && p.enrolledMdn ? {
    name: p.firstName ?? "User",
    mdn: p.enrolledMdn ?? "000000000",
    visitorId: p.visitorId ?? de(),
    requestId: p.requestId ?? de()
  } : {
    name: "Visitor",
    mdn: de(),
    // create generic number for chatbot
    visitorId: de(),
    // same with mdn..
    requestId: de()
  }, g = () => {
    Ct("cognitoUserSession"), h();
  }, m = re(() => ({
    accountInfo: a,
    userInfo: r,
    isFetchingAccountInfo: l,
    isLoggedIn: i,
    refetchUser: g
  }), [a, r, l, i, g]);
  return u ? /* @__PURE__ */ e.jsx(Io, {}) : /* @__PURE__ */ e.jsx(lt.Provider, { value: m, children: o });
}, ie = () => xe(lt), dt = pe({
  chatRequestId: void 0,
  isChatSessionStarting: !0,
  setChatRequestId: () => {
  },
  startChatSession: async () => {
  },
  isTyping: !1,
  setIsTyping: () => {
  },
  selectedDevice: void 0,
  setSelectedDevice: () => {
  },
  deviceList: void 0
}), To = ({
  children: o,
  selectedDevice: i,
  deviceList: t
}) => {
  var w, I;
  const { isOpen: n } = ae(), { userInfo: a } = ie(), { chatConfig: s } = B(), { language: d } = he(), [r, c] = q(""), [l, h] = q(!1), [u, x] = q(!1), [g, m] = q(i), p = async ({
    chatReason: y,
    requestType: j,
    passedChatConfig: S
  }) => {
    h(!0), x(!0);
    const T = await wt(
      S ?? s,
      d,
      y,
      j,
      a
    );
    return c((T == null ? void 0 : T.chatRequestId) ?? ""), h(!1), x(!1), T == null ? void 0 : T.chatRequestId;
  };
  De({
    queryKey: [
      "getChatSurvey",
      s == null ? void 0 : s.chat.clientName,
      (w = s == null ? void 0 : s.chatSurvey) == null ? void 0 : w.surveyTriggerPoint
    ],
    queryFn: () => Je(s),
    onSuccess: () => {
      console.debug("Chat survey preloaded");
    },
    onError: () => {
      console.debug("Chat survey failed to preload");
    },
    staleTime: 0,
    refetchOnMount: !1,
    enabled: !(s != null && s.disableSurvey) && !!((I = s == null ? void 0 : s.chatSurvey) != null && I.hasPostChatSurvey) && n
  });
  const C = re(
    () => ({
      chatRequestId: r,
      isChatSessionStarting: l,
      setChatRequestId: c,
      startChatSession: p,
      isTyping: u,
      setIsTyping: x,
      selectedDevice: g,
      setSelectedDevice: m,
      deviceList: t
    }),
    [
      r,
      l,
      c,
      p,
      u,
      x,
      g,
      m,
      t
    ]
  );
  return /* @__PURE__ */ e.jsx(dt.Provider, { value: C, children: o });
}, J = () => xe(dt), ut = pe({
  chatStatus: O.Initiated,
  setChatStatus: () => {
  },
  chatInputStatus: K.Hidden,
  setChatInputStatus: () => {
  },
  isChatConnecting: !1,
  isChatEnded: !1,
  isChatBusy: !1,
  isLiveChatActive: !1,
  showIdleMessage: !1,
  isChatbotEnded: !1,
  setShowIdleMessage: () => {
  },
  setIsChatbotEnded: () => {
  },
  isSurveyVisible: !1,
  setIsSurveyVisible: () => {
  },
  isCallbackInputActive: !1,
  setIsCallbackInputActive: () => {
  }
}), ko = ({ children: o }) => {
  const [i, t] = q(O.Initiated), [n, a] = q(K.Hidden), [s, d] = q(!1), [r, c] = q(!1), [l, h] = q(!1), [u, x] = q(!1), g = [O.User_Disconnect, O.Ended].includes(i), m = [O.Connecting, O.Transferring].includes(i), p = i === O.Agent_Busy, C = [O.Connected, O.Transferred].includes(i), w = re(() => ({
    chatStatus: i,
    setChatStatus: t,
    chatInputStatus: n,
    setChatInputStatus: a,
    isChatConnecting: m,
    isChatBusy: p,
    isChatEnded: g,
    isLiveChatActive: C,
    showIdleMessage: r,
    isChatbotEnded: l,
    setShowIdleMessage: c,
    setIsChatbotEnded: h,
    isSurveyVisible: s,
    setIsSurveyVisible: d,
    isCallbackInputActive: u,
    setIsCallbackInputActive: x
  }), [
    i,
    t,
    n,
    a,
    m,
    p,
    g,
    C,
    r,
    l,
    c,
    h,
    s,
    d,
    u,
    x
  ]);
  return /* @__PURE__ */ e.jsx(ut.Provider, { value: w, children: o });
}, _ = () => xe(ut), ht = pe({
  isTimeoutWarningVisible: !1,
  isTimedOut: !1,
  resetChatTimeout: () => {
  },
  stopChatTimeout: () => {
  },
  handleResetIdleTimeout: () => {
  },
  count: 0
}), Mo = ({ children: o }) => {
  var C, w, I;
  const { chatConfig: i } = B(), { setShowIdleMessage: t, isLiveChatActive: n } = _(), a = 1e3, s = Number(((C = i == null ? void 0 : i.flow) == null ? void 0 : C.chatTimeoutWarningInMs) ?? 12e4) / a, d = Number(((w = i == null ? void 0 : i.flow) == null ? void 0 : w.chatTimeoutInMs) ?? 24e4) / a, [r, { startCountdown: c, stopCountdown: l, resetCountdown: h }] = nt({
    countStart: 0,
    countStop: Number(((I = i == null ? void 0 : i.flow) == null ? void 0 : I.chatTimeoutInMs) ?? 24e4) / a,
    intervalMs: a,
    isIncrement: !0
  }), u = n ? !1 : r === s, x = n ? !1 : r === d, g = () => {
    h(), c();
  }, m = () => {
    g(), t(!1);
  }, p = re(() => ({
    isTimeoutWarningVisible: u,
    isTimedOut: x,
    resetChatTimeout: g,
    stopChatTimeout: l,
    handleResetIdleTimeout: m,
    count: r
  }), [
    u,
    x,
    g,
    l,
    m,
    r
  ]);
  return /* @__PURE__ */ e.jsx(ht.Provider, { value: p, children: o });
}, Re = () => xe(ht), pt = pe({
  messages: [],
  addMessage: () => {
  },
  clearMessages: () => {
  },
  handleAddMessageWithTimeout: () => {
  }
}), xt = {
  title: "Please select one of the following options",
  selection: [
    {
      title: "General Inquiries",
      description: "Contact us about any program or plan support."
    },
    {
      title: "Tech Support",
      description: "Tech Experts can help you with device troubleshooting or other tech-related issues."
    }
  ]
}, Ao = ({ children: o }) => {
  var j, S, T, L, U, A;
  const { deviceList: i } = J(), { chatConfig: t } = B(), { userInfo: n } = ie(), { handleResetIdleTimeout: a } = Re(), { setHasChatsPending: s } = ae(), { setChatInputStatus: d } = _(), r = ((S = (j = t == null ? void 0 : t.flow) == null ? void 0 : j.chatStartMessage) == null ? void 0 : S.replace("{{username}}", n.name)) ?? `Hi ${n.name ?? "User"}, please select one of the following options for further assistance.`, c = ((T = t == null ? void 0 : t.flow) == null ? void 0 : T.chatSupportInfo) ?? xt, l = i || Ge(((L = t == null ? void 0 : t.flow) == null ? void 0 : L.deviceSelectionKey) ?? "deviceOptions"), h = c.selection.map((F) => {
    if (!(t != null && t.disableTechSupport && (t != null && t.disableChatbotTechSupport) && F.title === "Tech Support") && !(t != null && t.disableGeneralInquiry && F.title === "General Inquiries"))
      return {
        source: "chatbot",
        title: F.title,
        content: F.description,
        systemMessageFrom: "chatIntroSelection"
      };
  }).filter((F) => !!F), u = !((U = t == null ? void 0 : t.flow) != null && U.hasInquiryTypeSelection && ((A = t == null ? void 0 : t.flow) != null && A.hasDeviceSelection) && l), x = () => {
    var te, ne;
    let F = [
      {
        source: "chatbot",
        content: r,
        systemMessageFrom: "chatStartMessage"
      }
    ];
    return (te = t == null ? void 0 : t.flow) != null && te.hasInquiryTypeSelection ? F = [
      ...F,
      {
        source: "chatbot",
        content: "",
        systemMessageFrom: "chatInquiryTypeSelection"
      }
    ] : (ne = t == null ? void 0 : t.flow) != null && ne.hasDeviceSelection && l ? F = [
      ...F,
      {
        source: "chatbot",
        content: "",
        systemMessageFrom: "chatDeviceSelection"
      }
    ] : (h == null ? void 0 : h.length) === 1 ? h[0].title === "General Inquiries" && (F = [
      ...F,
      {
        source: "chatbot",
        content: h[0].title,
        systemMessageFrom: "chatSupportOption"
      }
    ]) : F = [...F, ...h], F;
  }, [g, m] = q(x), p = (F) => {
    s(!0), m((te) => [...te, F]);
  }, C = () => {
    m([]);
  }, { language: w } = he(), I = (F) => {
    p(F), a();
  };
  ee(() => {
    u && (h == null ? void 0 : h.length) === 1 && (h[0].title === "General Inquiries" ? d(K.Disabled) : h[0].title === "Tech Support" && (t != null && t.disableChatbotTechSupport ? t != null && t.disableTechSupport || d(K.TechSupportInput) : d(K.TechSupportChatbotInput)));
  }, []);
  const y = re(() => ({
    messages: g,
    addMessage: p,
    clearMessages: C,
    handleAddMessageWithTimeout: I
  }), [g, p, C, w]);
  return /* @__PURE__ */ e.jsx(pt.Provider, { value: y, children: o });
}, X = () => xe(pt), qo = () => {
  const { chatRequestId: o } = J(), { chatConfig: i } = B(), [t, n] = q(!1), [a, s] = q();
  return ee(() => {
    var c;
    let d;
    const r = async () => {
      const l = await jt({
        chatConfig: i,
        requestId: o
      });
      l && s(l);
    };
    return t && o && (r(), d = setInterval(
      r,
      parseInt(((c = i == null ? void 0 : i.flow) == null ? void 0 : c.chatStatsPollingInMs) ?? "30000")
    )), () => clearInterval(d);
  }, [t]), {
    setIsStatsPollingActive: n,
    chatQueue: a
  };
}, gt = pe({
  chatQueue: void 0,
  startLiveChat: () => Promise.resolve(),
  handleUserCancelLiveChat: () => Promise.resolve(),
  handleUserEndLiveChat: () => Promise.resolve(),
  reloadMessages: () => Promise.resolve(),
  handleUserMessage: () => Promise.resolve()
}), Fo = ({ children: o }) => {
  var Ae;
  const i = st(), { chatConfig: t } = B(), { chatRequestId: n, setChatRequestId: a, startChatSession: s, setIsTyping: d } = J(), { addMessage: r, clearMessages: c } = X(), { setChatStatus: l, setIsChatbotEnded: h } = _(), { userInfo: u, isLoggedIn: x } = ie(), [g, m] = q(""), { setIsStatsPollingActive: p, chatQueue: C } = qo(), { connect: w, subscription: I } = qe({
    query: It,
    onData: (b) => {
      var Z, ge;
      const W = (ge = (Z = b == null ? void 0 : b.data) == null ? void 0 : Z.onCreateConversation) == null ? void 0 : ge.conversationId;
      ke(W), m(W);
    },
    onError: (b) => console.error("Error in onCreateConversation", b)
  }), { connect: y, subscription: j } = qe({
    query: vt,
    onData: (b) => {
      var W;
      A((W = b == null ? void 0 : b.data) == null ? void 0 : W.onUpdateChatRequest);
    },
    onError: (b) => console.error("Error in onUpdateChatRequest", b)
  }), { connect: S, subscription: T } = qe({
    query: Tt,
    onData: (b) => {
      F(b.data.onCreateMessage);
    },
    onError: (b) => {
      console.error("Error in onCreateMessage, reloading chat messages", b), ne();
    }
  }), { connect: L, subscription: U } = qe({
    query: kt,
    onData: (b) => {
      d(b.data.onAgentTyping.agentTyping);
    },
    onError: (b) => console.error("Error in onAgentTyping", b)
  }), A = async (b) => {
    var W;
    if (b.requestStatus)
      switch ((W = b.requestStatus) == null ? void 0 : W.toUpperCase()) {
        case O.Agent_Ended:
        case O.Ended:
          if (b.isTransferred && b.wrapUpCode === "Transferred")
            return;
          l(O.Ended), h(!0), b.requestId && u.visitorId && await Q.createChatAudit({
            requestId: b.requestId,
            visitorId: u.visitorId,
            createdAt: /* @__PURE__ */ new Date(),
            auditLog: `${b.wrapUpCode === "Resolved" ? "Chat Resolved" : "Chat Not Resolved"}`
          });
          break;
        case O.Transferring:
          n && await Q.createChatAudit({
            requestId: n,
            visitorId: u.visitorId,
            createdAt: /* @__PURE__ */ new Date(),
            auditLog: "Transferring"
          }), l(O.Transferring), D(), a(b.transferredRequestId), be(b.transferredRequestId);
          break;
        case O.Transferred:
          await Q.createChatAudit({
            requestId: b.requestId,
            visitorId: u.visitorId,
            createdAt: /* @__PURE__ */ new Date(),
            auditLog: "Transferred"
          }), l(O.Transferred);
          break;
        default:
          return;
      }
  }, F = async (b) => {
    if (b.source.trim().toUpperCase() === uo.Agent) {
      if (b.messageStatus === "3")
        return;
      r({
        source: b.source,
        content: b.content
      });
      const W = {
        ...b,
        messageStatus: "3"
      };
      await Q.createChatMessage(W);
    }
  }, te = async (b) => {
    const W = Fe(b, u.visitorId, g);
    r(W), await Q.createChatMessage(W);
  }, ne = async () => {
    try {
      setTimeout(async () => {
        const {
          data: { getMessages: b }
        } = await Q.getChatMessages(u.visitorId, g);
        b.length > 0 && (D(), c(), b.sort((W, Z) => W.createdAt > Z.createdAt ? 1 : -1).forEach((W) => {
          W.messageType !== "canvas" && r(W);
        }), be(n));
      }, 1e3);
    } catch (b) {
      console.error("Failed to reload chat messages", b);
    }
  }, be = async (b) => {
    b && !g ? (w([b]), y([b])) : b && g && (ke(g), y([b]));
  }, ke = (b) => {
    b && (console.info("conversation starting"), S([b]), L([b]), l(O.Connected), r({
      source: "chatbot",
      content: "",
      systemMessageFrom: "chatConnectedToAgent"
    }), p(!1), ye(), fe(), n && u.visitorId && Q.createChatAudit({
      requestId: n,
      visitorId: u.visitorId,
      createdAt: /* @__PURE__ */ new Date(),
      auditLog: "Chat Acknowledged"
    }));
  }, [
    ce,
    {
      startCountdown: Me,
      stopCountdown: fe,
      resetCountdown: ye
    }
  ] = nt({
    countStart: 0,
    countStop: Number(((Ae = t == null ? void 0 : t.flow) == null ? void 0 : Ae.chatTimeoutInMs) ?? 24e4) / 1e3,
    intervalMs: 1e3,
    isIncrement: !0
  });
  ee(() => {
    var W, Z;
    const b = Number(((W = t == null ? void 0 : t.flow) == null ? void 0 : W.chatConnectingTimeoutInMs) ?? 6e4) / 1e3;
    if (ce % 10 === 0 && console.debug(
      `Chat has been connecting for: ${ce} out of ${b} seconds`
    ), ce >= b) {
      if (Se(), r({
        source: "chatbot",
        content: "",
        systemMessageFrom: "chatAgentsUnavailableMsg"
      }), t != null && t.callback) {
        r({
          source: "chatbot",
          content: ((Z = t == null ? void 0 : t.callback) == null ? void 0 : Z.callbackMessage) ?? "Alternatively, you can request a callback by leaving your contact details. Our Tech Specialists will contact you during operating hours.",
          systemMessageFrom: "chatSupportOptionMsg"
        }), x && z(
          () => r({
            source: "chatbot",
            content: "",
            systemMessageFrom: "chatDialogQuestion"
          }),
          1e3
        );
        return;
      }
      z(
        () => {
          var ge;
          return r({
            source: "chatbot",
            content: "chatbot response",
            systemMessageFrom: ((ge = t == null ? void 0 : t.flow) == null ? void 0 : ge.actionIfNoLiveChat) ?? "chatSubmitAnEnquiry"
          });
        },
        500
      );
    }
  }, [ce]);
  const D = co(() => {
    I == null || I.unsubscribe(), j == null || j.unsubscribe(), T == null || T.unsubscribe(), U == null || U.unsubscribe();
  }, [j, I, T, U]), R = async ({
    chatAction: b,
    isSoluto: W
  }) => {
    d(!0);
    const Z = {
      ...t,
      chat: {
        ...t == null ? void 0 : t.chat,
        ...W && { program: "SOLUTO" }
      }
    }, { isServiceable: ge, schedule: ze } = await Mt(Z);
    if (ze && i.setQueryData(["getChatSchedule"], ze), !ge) {
      if (d(!1), r({
        source: "chatbot",
        content: "",
        systemMessageFrom: "chatOutOfOfficeMsg"
      }), t != null && t.callback) {
        P();
        return;
      }
      z(
        () => {
          var Ce;
          return r({
            source: "chatbot",
            content: "chatbot response",
            systemMessageFrom: ((Ce = t == null ? void 0 : t.flow) == null ? void 0 : Ce.actionIfNoLiveChat) ?? "chatSubmitAnEnquiry"
          });
        },
        500
      );
      return;
    }
    let le = "";
    if (b === "queue")
      le = de();
    else if (n)
      le = n;
    else {
      const Ce = await s({
        chatReason: "Technical Support",
        requestType: "Technical Support",
        passedChatConfig: Z
      });
      Ce && (le = Ce);
    }
    l(O.Connecting), Me(), a(le), be(le);
    const {
      status: ft,
      requestId: yt,
      taskSid: St
    } = await At({
      chatConfig: Z,
      transferRequestId: le,
      requestId: le,
      action: b
    });
    yt && St && ft === "QUEUED" ? p(!0) : (l(O.Agent_Busy), await Q.createChatAudit({
      requestId: le ?? "",
      visitorId: u.visitorId,
      createdAt: /* @__PURE__ */ new Date(),
      auditLog: "All Agents are Busy"
    })), d(!1);
  }, P = () => {
    z(
      () => {
        var b;
        return r({
          source: "chatbot",
          content: ((b = t == null ? void 0 : t.callback) == null ? void 0 : b.callbackMessage) ?? "Alternatively, you can request a callback by leaving your contact details. Our Tech Specialists will contact you during operating hours.",
          systemMessageFrom: "chatSupportOptionMsg"
        });
      },
      500
    ), x && z(
      () => r({
        source: "chatbot",
        content: "",
        systemMessageFrom: "chatDialogQuestion"
      }),
      1e3
    );
  }, E = async () => {
    n && Be({
      action: "cancel",
      chatConfig: t,
      requestId: n
    }), p(!1), ye(), fe(), l(O.Ended);
  }, Y = async () => {
    n && Be({
      action: "customer_ended",
      chatConfig: t,
      requestId: n
    }), p(!1), ye(), fe(), l(O.User_Disconnect), D();
  }, Se = async () => {
    l(O.Agent_Busy), n && await Q.createChatAudit({
      requestId: n,
      visitorId: u.visitorId,
      createdAt: /* @__PURE__ */ new Date(),
      auditLog: "All Agents are Busy"
    }), p(!1), ye(), fe();
  }, Ee = re(() => ({
    chatQueue: C,
    startLiveChat: R,
    handleUserCancelLiveChat: E,
    handleUserEndLiveChat: Y,
    handleUserMessage: te,
    reloadMessages: ne
  }), [
    R,
    E,
    Y,
    ne,
    n
  ]);
  return /* @__PURE__ */ e.jsx(gt.Provider, { value: Ee, children: o });
}, Te = () => xe(gt), oe = () => {
  const { onClose: o } = ae(), { refetchUser: i } = ie(), { setChatRequestId: t } = J(), { handleUserEndChatbot: n, setQuestion: a } = ve(), { handleUserEndLiveChat: s, handleUserCancelLiveChat: d } = Te(), { isChatConnecting: r, isChatEnded: c, isSurveyVisible: l, isChatbotEnded: h, setIsChatbotEnded: u } = _(), x = () => {
    n(), s();
  }, g = () => {
    t(""), a == null || a(""), o(), i();
  };
  return { terminateChat: g, handleEndChatSession: () => {
    u(!c), r ? d() : x(), (l || h || c) && g();
  } };
}, mt = pe({
  // isChatbotTokenLoading: true,
  handleChatbotInquiries: async () => {
  },
  handleChatbotFeedback: async () => {
  },
  handleUserMessageChatbot: () => {
  },
  handleChatFeedback: async () => {
  },
  handleChatDialogYesAction: () => {
  },
  handleChatDialogNoAction: () => {
  },
  handleUserEndChatbot: () => {
  },
  setQuestion: () => {
  },
  handleUserCallbackInput: async () => {
  },
  handleUserMessageTechSupportChatbot: () => {
  }
}), Do = ({
  children: o,
  question: i,
  setQuestion: t
}) => {
  const { isLoggedIn: n, userInfo: a } = ie(), { chatConfig: s, baseApiConfig: d } = B(), { chatRequestId: r, startChatSession: c, setIsTyping: l } = J(), { startLiveChat: h } = Te(), { handleAddMessageWithTimeout: u, addMessage: x, messages: g } = X(), { handleEndChatSession: m } = oe(), [p, C] = q(""), [w, I] = q(0), y = ot(g);
  ee(() => {
    y.current = g;
  }, [g]), De({
    queryKey: ["chatBotToken", r],
    queryFn: async () => await qt(s, r),
    onSuccess: (D) => {
      C(D.token);
    },
    enabled: !!r && !!s
  });
  const j = async (D, R, P) => {
    var E;
    l(!0), te(D, R, P), l(!1), w >= Number(((E = s == null ? void 0 : s.flow) == null ? void 0 : E.noThresholdCount) || 0) && !(s != null && s.disableTechSupport) ? (z(
      () => u({
        source: "chatbot",
        content: "Connecting you to the next available agent",
        systemMessageFrom: "chatSupportOptionMsg"
      }),
      500
    ), z(() => L(), 1e3)) : (u({
      source: "chatbot",
      content: "General Inquiries",
      systemMessageFrom: "chatSupportOption"
    }), I(w + 1));
  }, S = () => {
    u({
      source: "chatbot",
      content: "",
      systemMessageFrom: "chatOtherInquiriesQuestion"
    });
  }, T = () => {
    w >= 2 && !(s != null && s.disableTechSupport) ? h({ isSoluto: !0, chatAction: "directTransfer" }) : (u({
      source: "chatbot",
      content: "General Inquiries",
      systemMessageFrom: "chatSupportOption"
    }), I(w + 1));
  }, L = () => {
    u({
      source: "chatbot",
      content: "Connect to Agent",
      title: "To ensure you get the help you need, we'll transfer you to one of our live agents.",
      systemMessageFrom: "chatBotContentAction",
      systemMessage: [
        {
          key: 0,
          content: "Connect to Agent",
          actionType: ["Connect to Agent"],
          suggestionList: []
        }
      ]
    });
  }, U = () => {
    z(
      () => u({
        source: "chatbot",
        content: "We encountered an error processing your request. Please try again, Sorry for the trouble.",
        systemMessageFrom: "chatSupportOptionMsg"
      }),
      500
    );
  }, A = () => {
    U(), z(
      () => u({
        source: "chatbot",
        content: "General Inquiries",
        systemMessageFrom: "chatSupportOption"
      }),
      1e3
    );
  }, F = async ({
    chatRequestId: D,
    message: R
  }) => {
    l(!0);
    const P = await Ft(
      s,
      p,
      D,
      de(),
      { message: R }
    );
    return l(!1), P;
  }, te = async (D, R, P) => await Dt(
    s,
    p,
    r,
    de(),
    {
      selected_question: D,
      feedback_question: R,
      feedback: P
    }
  ), ne = async () => {
    r && Q.updateChatRequest({
      requestId: r,
      requestStatus: "Customer Ended",
      endTimestamp: (/* @__PURE__ */ new Date()).toISOString(),
      wrapUpCode: ""
    });
  }, be = async (D) => {
    var R;
    x({
      source: "user",
      content: D
    }), await Xe(d, {
      mdn: a.mdn,
      name: a.name,
      altMdn: D
    }), x({
      source: "agent",
      content: ((R = s == null ? void 0 : s.callback) == null ? void 0 : R.callbackResponse) ?? "Our Tech Specialist will contact you next 2 business days during operating hours. Thank you."
    }), z(() => {
      m();
    }, 5e3);
  };
  function ke(D) {
    if (D instanceof Array) {
      const R = D.filter((E) => E.content).map((E, Y) => {
        const Se = E.content ? lo(E.content).trim() : "", Ee = E.action_type ?? [], Ae = E.question ?? "";
        return {
          key: Y,
          content: Se,
          action_type: Ee,
          question: Ae
        };
      }), P = () => {
        x({
          source: "agent",
          content: "Sorry we couldn't understand your query. Please rephrase your query."
        });
      };
      R.length > 0 && (R.length === 1 && R[0].action_type.length === 0 && R[0].content.includes("Sorry we couldn't understand your query") || R.length === 1 && R[0].action_type.includes("Connect me with an agent") && !n ? P() : (x({
        source: "chatbot",
        content: "I've gathered all the information below that could help you.",
        systemMessageFrom: "chatSupportOptionMsg"
      }), z(() => {
        x({
          source: "chatbot",
          content: "",
          systemMessageFrom: "chatServiceRequest",
          chatbotInquiries: D
        });
      }, 500)));
      return;
    }
    switch (D.question) {
      case "Greeting":
        const R = {
          source: "agent",
          content: D.content
        };
        x(R);
        break;
      case "Callback":
      case "No relevant FAQ":
        u({
          source: "chatbot",
          content: D.content,
          systemMessageFrom: "chatSupportOptionMsg"
        }), L();
        break;
      case "Keyword not detected":
        u({
          source: "chatbot",
          content: "We're sorry that our response didn't fully address your question. ",
          systemMessageFrom: "chatSupportOptionMsg"
        }), L();
        break;
      default:
        u({
          source: "chatbot",
          content: D.content
        });
    }
  }
  async function ce(D, R) {
    l(!0), u({
      source: "user",
      content: D
    });
    let P;
    r ? P = r : P = await c({
      chatReason: R ? D : "General Inquiry",
      requestType: "General Inquiry"
    });
    const E = await F({
      chatRequestId: P,
      message: D
    });
    E.length === 0 ? A() : ke(E), l(!1);
  }
  async function Me(D) {
    l(!0), await u({
      source: "user",
      content: D
    });
    let R;
    r ? R = r : R = await c({
      chatReason: "Technical Support",
      requestType: "Technical Support"
    });
    const P = await fe({
      chatRequestId: R
    });
    if (!P)
      U();
    else if (P.action === "TRANSFER" && P.actionType === "FORCE")
      h({ isSoluto: !0, chatAction: "directTransfer" });
    else if (P.action === "TRANSFER" && P.actionType !== "FORCE") {
      const E = "Transfer to Agent", Y = {
        source: "chatbot",
        content: E,
        title: P.answer,
        systemMessageFrom: "chatBotContentAction",
        systemMessage: [
          {
            key: 0,
            content: E,
            actionType: [E],
            suggestionList: []
          }
        ]
      };
      x(Y);
    } else if (!P.action) {
      const E = {
        source: "chatbot",
        content: P.answer,
        systemMessageFrom: "chatSupportOptionMsg"
      };
      x(E);
    }
    l(!1);
  }
  const fe = async ({
    chatRequestId: D
  }) => {
    l(!0);
    const P = {
      chat_transcript: y.current.filter(({ content: Y }) => Y).map(({ source: Y, content: Se }) => ({
        role: Y === "user" ? "user" : "assistant",
        content: Se
      })),
      request_id: D,
      visitor_id: a.visitorId,
      mdn: a.mdn,
      partner: s == null ? void 0 : s.chat.clientName,
      program: s == null ? void 0 : s.chat.program
    }, E = await Rt({
      chatConfig: s,
      requestBody: P
    });
    return l(!1), E;
  };
  ee(() => {
    r && i && (ce(i), t == null || t(""));
  }, [r, i]);
  const ye = re(() => ({
    // isChatbotTokenLoading,
    handleChatbotInquiries: F,
    handleChatbotFeedback: te,
    handleUserMessageChatbot: ce,
    handleChatFeedback: j,
    handleChatDialogYesAction: S,
    handleChatDialogNoAction: T,
    handleUserEndChatbot: ne,
    setQuestion: t,
    handleUserCallbackInput: be,
    handleUserMessageTechSupportChatbot: Me
  }), [
    F,
    te,
    ce,
    j,
    S,
    T,
    ne,
    t,
    be,
    Me
  ]);
  return /* @__PURE__ */ e.jsx(mt.Provider, { value: ye, children: o });
}, we = {
  hold: "Hold tight...",
  queued: "All our Tech Experts are busy serving our customers.",
  cancel: "Are you sure you want to cancel?",
  findSpecialist: "We're finding a Tech Specialist for you.",
  techSpecialist: "One of our Tech Specialists will be with you soon"
};
function Ro({ showCancel: o }) {
  const { data: i } = N(), { theme: t } = i, {
    components: { chat: n }
  } = t, { isOpen: a, onOpen: s, onClose: d } = ho(), { chatRequestId: r } = J();
  ae();
  const { chatQueue: c } = Te(), { handleEndChatSession: l } = oe(), h = c && c.queueIndex > 0 ? c.queueIndex : 0, u = c && c.queueIndex > 0;
  return /* @__PURE__ */ e.jsxs($, { flexFlow: "column nowrap", align: "center", justify: "center", p: 4, h: "full", w: "full", children: [
    /* @__PURE__ */ e.jsxs(
      $,
      {
        display: a ? "none" : "flex",
        flexFlow: "column nowrap",
        align: "center",
        justify: "space-between",
        w: "full",
        gap: "75px",
        textAlign: "center",
        children: [
          /* @__PURE__ */ e.jsx(rt, { children: u ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(G, { fontSize: "3xl", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: we.queued,
                translationKey: "Global/chatConnectingQueued"
              }
            ) }),
            /* @__PURE__ */ e.jsxs(
              G,
              {
                bgColor: "black",
                color: "white",
                py: "2px",
                px: "5px",
                borderRadius: "3px",
                children: [
                  "You are number",
                  " ",
                  /* @__PURE__ */ e.jsx(G, { as: "span", fontWeight: "semibold", color: "yellow", children: h }),
                  " ",
                  "in the queue..."
                ]
              }
            )
          ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx($, { p: 4, children: /* @__PURE__ */ e.jsx($, { borderRadius: 8, px: 5, py: 4, children: /* @__PURE__ */ e.jsx(po, {}) }) }),
            /* @__PURE__ */ e.jsx(G, { fontSize: "3xl", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: we.hold,
                translationKey: "Global/chatConnectingHold"
              }
            ) }),
            /* @__PURE__ */ e.jsx(G, { fontSize: "lg", fontWeight: "light", textAlign: "center", children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: we.findSpecialist,
                translationKey: "Global/chatConnectingFindSpecialist"
              }
            ) })
          ] }) }),
          (r || o) && /* @__PURE__ */ e.jsx(
            V,
            {
              variant: "tertiary",
              as: G,
              py: 4,
              px: 5,
              textDecor: "underline",
              fontWeight: "bold",
              cursor: "pointer",
              onClick: s,
              children: u ? /* @__PURE__ */ e.jsx(
                f,
                {
                  text: "Leave Chat",
                  translationKey: "Global/chatQueueLeaveChat"
                }
              ) : /* @__PURE__ */ e.jsx(
                f,
                {
                  text: "Cancel",
                  translationKey: "Global/chatConnectingCancel"
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(
      $,
      {
        flexFlow: "column nowrap",
        align: "start",
        textAlign: "center",
        display: a ? "block" : "none",
        children: [
          /* @__PURE__ */ e.jsx(G, { fontSize: "3xl", fontWeight: "light", lineHeight: "43.52px", mb: "10px", children: /* @__PURE__ */ e.jsx(
            f,
            {
              text: we.techSpecialist,
              translationKey: "Global/chatConnectingTechSpecialist"
            }
          ) }),
          /* @__PURE__ */ e.jsx(G, { fontSize: "lg", fontWeight: "light", mb: 6, children: /* @__PURE__ */ e.jsx(
            f,
            {
              text: we.cancel,
              translationKey: "Global/chatConnectingWantToCancel"
            }
          ) }),
          /* @__PURE__ */ e.jsxs($, { justify: "space-around", w: "full", gap: 6, children: [
            /* @__PURE__ */ e.jsx(
              H,
              {
                px: 5,
                py: 3,
                flex: 1,
                border: "1px",
                borderColor: "brand.neutral.deep",
                bg: n.surface,
                textAlign: "center",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: "bold",
                color: n.onSurface,
                onClick: l,
                children: /* @__PURE__ */ e.jsx(f, { text: "Yes", translationKey: "Global/chatConnectingYes" })
              }
            ),
            /* @__PURE__ */ e.jsx(
              H,
              {
                px: 5,
                py: 3,
                flex: 1,
                border: "1px",
                borderColor: "brand.neutral.deep",
                bg: n.surface,
                textAlign: "center",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: "bold",
                color: n.onSurface,
                onClick: d,
                children: /* @__PURE__ */ e.jsx(f, { text: "No", translationKey: "Global/chatConnectingNo" })
              }
            )
          ] })
        ]
      }
    )
  ] });
}
const Eo = () => {
  var x, g, m, p, C;
  const { data: o } = N(), { theme: i } = o, {
    components: { chat: t }
  } = i, { chatConfig: n, firebaseConfig: a } = B(), { chatRequestId: s } = J();
  ae();
  const { showIdleMessage: d, setIsSurveyVisible: r } = _(), { handleEndChatSession: c } = oe(), { imageUrl: l } = Ve(
    t.thankYouIconSlug,
    n == null ? void 0 : n.contentful.space,
    n == null ? void 0 : n.contentful.token,
    n == null ? void 0 : n.contentful.env,
    a
  ), h = ((x = n == null ? void 0 : n.flow) == null ? void 0 : x.chatEndHeaderText) ?? `Thank you for contacting ${(g = n == null ? void 0 : n.flow) == null ? void 0 : g.chatHeaderText}`;
  return !(n != null && n.disableSurvey) && ((m = n == null ? void 0 : n.chatSurvey) == null ? void 0 : m.hasPostChatSurvey) && !!s ? /* @__PURE__ */ e.jsxs(
    $,
    {
      h: "full",
      direction: "column",
      w: "full",
      align: "center",
      p: "20px",
      justify: "space-between",
      overflowY: "auto",
      children: [
        /* @__PURE__ */ e.jsxs(
          $,
          {
            flexFlow: "column nowrap",
            align: "center",
            justify: "center",
            w: "full",
            gap: 2,
            minHeight: "fit-content",
            my: "auto",
            children: [
              /* @__PURE__ */ e.jsx(
                Ke,
                {
                  src: l ? Pe(l) : t.thankYouIcon
                }
              ),
              /* @__PURE__ */ e.jsx(
                G,
                {
                  align: "center",
                  fontSize: "3xl",
                  fontWeight: "light",
                  letterSpacing: "-0.352px",
                  lineHeight: "39.68px",
                  children: /* @__PURE__ */ e.jsx(
                    f,
                    {
                      text: h,
                      translationKey: "Global/chatEndInfoThankYou"
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsx(
                G,
                {
                  align: "center",
                  fontSize: "20px",
                  p: "10px",
                  fontWeight: "light",
                  letterSpacing: "-0.352px",
                  lineHeight: "26px",
                  children: d ? /* @__PURE__ */ e.jsx(
                    f,
                    {
                      text: "It looks like you’ve been away for a bit. We’ll need to close the session shortly. If you still need assistance, please feel free to start a new chat session. Thank you!",
                      translationKey: "Global/chatIdleEndedMessage"
                    }
                  ) : /* @__PURE__ */ e.jsx(
                    f,
                    {
                      text: ((p = n == null ? void 0 : n.flow) == null ? void 0 : p.chatEndDescriptionText) ?? "Help us learn how to improve our service by giving us your feedback.",
                      translationKey: "Global/chatEndedMessage"
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e.jsx(
          V,
          {
            w: "full",
            onClick: () => r(!0),
            bgColor: t.secondary,
            color: t.onSecondary,
            children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: "Rate our service",
                translationKey: "Global/chatNpsButtonTest"
              }
            )
          }
        )
      ]
    }
  ) : /* @__PURE__ */ e.jsxs(
    $,
    {
      flexFlow: "column nowrap",
      align: "center",
      justify: "center",
      w: "full",
      gap: 2,
      p: "10px",
      h: "full",
      overflowY: "auto",
      children: [
        /* @__PURE__ */ e.jsx(
          Ke,
          {
            src: l ? Pe(l) : t.thankYouIcon
          }
        ),
        /* @__PURE__ */ e.jsx(
          G,
          {
            align: "center",
            fontSize: "3xl",
            fontWeight: "light",
            letterSpacing: "-0.352px",
            lineHeight: "39.68px",
            children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: h,
                translationKey: "Global/chatEndInfoThankYou"
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          G,
          {
            align: "center",
            fontSize: "20px",
            p: "10px",
            fontWeight: "light",
            letterSpacing: "-0.352px",
            lineHeight: "26px",
            children: /* @__PURE__ */ e.jsx(
              G,
              {
                align: "center",
                fontSize: "20px",
                p: "10px",
                fontWeight: "light",
                letterSpacing: "-0.352px",
                lineHeight: "26px",
                children: d ? /* @__PURE__ */ e.jsx(
                  f,
                  {
                    text: "It looks like you’ve been away for a bit. We’ll need to close the session shortly. If you still need assistance, please feel free to start a new chat session. Thank you!",
                    translationKey: "Global/chatIdleEndedMessage"
                  }
                ) : /* @__PURE__ */ e.jsx(
                  f,
                  {
                    text: ((C = n == null ? void 0 : n.flow) == null ? void 0 : C.chatEndDescriptionText) ?? "Help us learn how to improve our service by giving us your feedback.",
                    translationKey: "Global/chatEndedMessage"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(
          G,
          {
            py: 4,
            px: 5,
            textDecor: "underline",
            fontWeight: "bold",
            cursor: "pointer",
            onClick: () => c(),
            children: /* @__PURE__ */ e.jsx(f, { text: "Close", translationKey: "Global/chatEndInfoClose" })
          }
        )
      ]
    }
  );
}, Po = ({ isBackVisible: o, onBack: i }) => {
  var l;
  const { onClose: t, toggleMinimize: n } = ae(), { handleEndChatSession: a } = oe(), { chatConfig: s } = B(), { data: d } = N(), { theme: r } = d, {
    components: { chat: c }
  } = r;
  return /* @__PURE__ */ e.jsx(k, { w: "full", p: 4, bg: c.primary, color: c.onPrimary, children: /* @__PURE__ */ e.jsx(Ie, { justify: "space-between", spacing: 6, children: /* @__PURE__ */ e.jsxs(M, { justify: "space-between", align: "center", w: "full", children: [
    /* @__PURE__ */ e.jsxs(M, { align: "center", children: [
      /* @__PURE__ */ e.jsx(
        V,
        {
          variant: "link",
          colorScheme: c.onPrimary,
          visibility: o ? "visible" : "hidden",
          minWidth: 6,
          leftIcon: o ? /* @__PURE__ */ e.jsx(ro, { boxSize: 5 }) : /* @__PURE__ */ e.jsx(e.Fragment, {}),
          onClick: i
        }
      ),
      /* @__PURE__ */ e.jsx(V, { variant: "link", visibility: "hidden", minWidth: 6 })
    ] }),
    /* @__PURE__ */ e.jsx(v, { fontSize: "xl", children: (l = s == null ? void 0 : s.flow) == null ? void 0 : l.chatHeaderText }),
    /* @__PURE__ */ e.jsxs(k, { children: [
      /* @__PURE__ */ e.jsx(
        V,
        {
          variant: "link",
          colorScheme: c.onPrimary,
          leftIcon: /* @__PURE__ */ e.jsx(ao, { boxSize: 3 }),
          minWidth: 6,
          onClick: n
        }
      ),
      /* @__PURE__ */ e.jsx(
        V,
        {
          variant: "link",
          colorScheme: c.onPrimary,
          leftIcon: /* @__PURE__ */ e.jsx(tt, { boxSize: 3 }),
          minWidth: 6,
          onClick: a
        }
      )
    ] })
  ] }) }) });
}, Oo = (o, i) => {
  ee(() => {
    if (o) {
      o.style.height = "0px";
      const { scrollHeight: t } = o;
      o.style.height = `${t}px`;
    }
  }, [o, i]);
}, Lo = () => {
  const { chatConfig: o } = B(), { resetChatTimeout: i } = Re(), {
    chatStatus: t,
    chatInputStatus: n,
    isCallbackInputActive: a,
    setChatInputStatus: s,
    isLiveChatActive: d
  } = _(), { startLiveChat: r, handleUserMessage: c } = Te(), { addMessage: l } = X(), {
    handleUserMessageChatbot: h,
    handleUserCallbackInput: u,
    handleUserMessageTechSupportChatbot: x
  } = ve(), g = ot(null), [m, p] = q(""), C = (A) => {
    t === O.Connected ? c(A) : a ? u(A) : n === K.TechSupportInput ? (l({
      source: "user",
      content: A
    }), s(K.Disabled), r({ chatAction: "directTransfer", isSoluto: !0 })) : n === K.TechSupportChatbotInput ? x(A) : h(A);
  }, w = !1;
  Oo(g.current, m);
  const { data: I } = N(), { theme: y } = I, {
    components: { chat: j }
  } = y, S = (A) => {
    A.code === "Enter" && (m.trim().length > 0 && T(m), A.preventDefault());
  }, T = (A) => {
    Et(A) || (C(A), p(""));
  }, { language: L } = he(), U = {
    "zh-Hant-TW": "發送訊息",
    "en-US": "Send a message",
    // english for now
    "ko-KR": "Send a message",
    "ms-MY": "Send a message",
    "th-TH": "Send a message"
  };
  return n === K.Hidden ? /* @__PURE__ */ e.jsx(e.Fragment, {}) : !d && (o != null && o.disableGeneralInquiry) && n !== K.TechSupportInput && n !== K.TechSupportChatbotInput ? /* @__PURE__ */ e.jsx(e.Fragment, {}) : /* @__PURE__ */ e.jsx(k, { w: "full", px: 4, py: 2, bgColor: "white", children: /* @__PURE__ */ e.jsxs(M, { justify: "space-between", align: "center", children: [
    /* @__PURE__ */ e.jsx(
      Ze,
      {
        ref: g,
        rows: 1,
        flex: 1,
        p: 0,
        resize: "none",
        w: "fit-content",
        variant: "unstyled",
        maxH: "80px",
        disabled: w,
        placeholder: U[L] ?? "Send a message",
        sx: {
          "::placeholder": {
            color: "black"
          },
          ":focus::placeholder": {
            color: "transparent"
          }
        },
        value: m,
        onChange: ({ target: A }) => {
          p(A.value), i();
        },
        onKeyDown: S
      }
    ),
    /* @__PURE__ */ e.jsx(
      V,
      {
        display: "flex",
        justifyContent: "right",
        variant: "unstyled",
        "aria-label": "send chat button",
        iconSpacing: 0,
        leftIcon: /* @__PURE__ */ e.jsx(ue, { src: j.sendIcon }),
        onClick: () => T(m)
      }
    )
  ] }) });
}, No = ({ handleResetIdleTimeout: o }) => {
  const { data: i } = N(), { theme: t } = i, {
    components: { chat: n }
  } = t;
  return /* @__PURE__ */ e.jsxs(k, { mx: "auto", mb: 3, className: "chatbot-node", textAlign: "center", marginTop: "auto", children: [
    /* @__PURE__ */ e.jsx(k, { color: n.onBackground, children: /* @__PURE__ */ e.jsx(
      f,
      {
        text: "We haven't received a response from you in a while. Just let us know if you're still with us.",
        translationKey: "Global/chatIdleWarningMessage"
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      V,
      {
        w: "full",
        mt: "10px",
        onClick: o,
        bgColor: n.secondary,
        color: n.onSecondary,
        children: /* @__PURE__ */ e.jsx(f, { text: "I'm Still Here", translationKey: "Global/chatIdleButton" })
      }
    )
  ] });
}, Wo = () => {
  const { data: o } = N(), { theme: i } = o, {
    components: { chat: t }
  } = i;
  return /* @__PURE__ */ e.jsxs(
    H,
    {
      sx: {
        borderRadius: "16px",
        padding: "15px",
        borderBottomLeftRadius: 0,
        lineHeight: "22px",
        display: "inline-flex",
        background: t.secondary,
        marginRight: "auto",
        gap: "5px",
        ".dot": {
          height: "8px",
          width: "8px",
          opacity: "0.3",
          borderRadius: "50%",
          position: "relative",
          WebkitAnimation: "dots .9s ease-in-out infinite",
          animation: "dots .9s ease-in-out infinite"
        },
        ".left": {
          WebkitAnimationDelay: "0.1s",
          background: t.onSecondary
        },
        ".center": {
          WebkitAnimationDelay: "0.2s",
          background: t.onSecondary
        },
        ".right": {
          WebkitAnimationDelay: "0.4s",
          background: t.onSecondary
        },
        "@keyframes dots": {
          "0%": {
            opacity: 1
          }
        },
        "@-webkit-keyframes dots": {
          "0%": {
            opacity: 1
          }
        }
      },
      children: [
        /* @__PURE__ */ e.jsx(H, { className: "dot left" }),
        /* @__PURE__ */ e.jsx(H, { className: "dot center" }),
        /* @__PURE__ */ e.jsx(H, { className: "dot right" })
      ]
    }
  );
}, Oe = ({
  question: o,
  customTranslationKey: i,
  onClickYes: t,
  onClickNo: n
}) => {
  const { isLiveChatActive: a } = _(), { data: s } = N(), { theme: d } = s, {
    components: { chat: r }
  } = d;
  return /* @__PURE__ */ e.jsxs(
    k,
    {
      p: 4,
      border: "1px solid",
      borderColor: "brand.border",
      borderRadius: 8,
      w: "full",
      mb: 4,
      background: "white",
      children: [
        /* @__PURE__ */ e.jsx(v, { mb: 4, children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: o,
            translationKey: `Global/${i ?? "chatDialogQuestion"}`
          }
        ) }),
        /* @__PURE__ */ e.jsx(M, { justify: "space-between", align: "center", children: /* @__PURE__ */ e.jsxs(Le, { columns: 2, spacing: 4, w: "full", children: [
          /* @__PURE__ */ e.jsx(
            se,
            {
              border: "1px solid",
              borderColor: "brand.neutral.deep",
              borderRadius: 8,
              px: 5,
              py: 3,
              cursor: a ? "not-allowed" : "pointer",
              opacity: a ? 0.5 : 1,
              _hover: a ? {} : {
                border: "2px",
                borderColor: "black"
              },
              bgColor: r.surface,
              color: r.onSurface,
              onClick: () => {
                a || n();
              },
              children: /* @__PURE__ */ e.jsx(f, { text: "No", translationKey: "Global/chatDialogNo" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            se,
            {
              border: "1px solid",
              borderColor: "brand.neutral.deep",
              borderRadius: 8,
              px: 5,
              py: 3,
              cursor: a ? "not-allowed" : "pointer",
              opacity: a ? 0.5 : 1,
              _hover: a ? {} : {
                border: "2px",
                borderColor: "black"
              },
              bgColor: r.surface,
              color: r.onSurface,
              onClick: () => {
                a || t();
              },
              children: /* @__PURE__ */ e.jsx(f, { text: "Yes", translationKey: "Global/chatDialogYes" })
            }
          )
        ] }) })
      ]
    }
  );
}, _e = {
  answerQuestion: "Did we answer your question?"
}, Go = ({ message: o }) => {
  var r;
  const [i, t] = q([]), n = me(), { handleChatFeedback: a, handleChatDialogYesAction: s } = ve(), { isLoggedIn: d } = ie();
  return /* @__PURE__ */ e.jsxs($, { flexFlow: "column nowrap", w: "full", mb: 4, className: "chatbot-node", children: [
    /* @__PURE__ */ e.jsx(G, { ml: 6, fontSize: "2xl", mb: 2, children: /* @__PURE__ */ e.jsx(
      f,
      {
        text: (o == null ? void 0 : o.title) ?? "",
        translationKey: `Global/chatServiceRequestTitle-${n}-${o == null ? void 0 : o.title}`
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      xo,
      {
        allowMultiple: !0,
        bg: "white",
        onChange: (c) => t(c),
        borderRadius: 8,
        children: (r = o.chatbotInquiries) == null ? void 0 : r.map(({ question: c, content: l }, h) => {
          const u = i.includes(h);
          return /* @__PURE__ */ e.jsxs(go, { children: [
            /* @__PURE__ */ e.jsx(H, { children: /* @__PURE__ */ e.jsxs(mo, { py: 6, px: "10px", children: [
              /* @__PURE__ */ e.jsx(
                H,
                {
                  as: "span",
                  textAlign: "left",
                  flex: "1",
                  pr: 2,
                  fontWeight: u ? "bold" : "normal",
                  children: /* @__PURE__ */ e.jsx(G, { children: c })
                }
              ),
              /* @__PURE__ */ e.jsx(bo, {})
            ] }) }),
            /* @__PURE__ */ e.jsxs(fo, { pb: 4, px: "10px", children: [
              /* @__PURE__ */ e.jsx(
                H,
                {
                  css: { whiteSpace: "pre-wrap", overflow: "auto" },
                  dangerouslySetInnerHTML: {
                    __html: zo(l) ?? ""
                  }
                }
              ),
              d && /* @__PURE__ */ e.jsx(H, { mt: 2, children: /* @__PURE__ */ e.jsx(
                Oe,
                {
                  question: _e.answerQuestion,
                  onClickYes: s,
                  onClickNo: () => a(
                    c,
                    _e.answerQuestion,
                    "No"
                  )
                }
              ) })
            ] })
          ] }, `${c}-${h}`);
        })
      }
    )
  ] });
}, zo = (o) => o == null ? void 0 : o.replaceAll(/\[(.*?)\]\((.*?)\)/g, (i, t, n) => `<a href="${n}" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: blue;">${t}</a>`), Bo = ({
  action: o,
  isLoggedIn: i,
  disableTechSupport: t,
  onStartChat: n,
  onChatAssistClick: a,
  getOnlineServiceFees: s
}) => {
  var r, c, l, h, u, x, g, m, p;
  const d = o === "Transfer to Agent";
  switch (o) {
    case "Connect to Agent":
    case "Cancel my current delivery":
    case "Connect me with an agent":
    case "Chat with a Tech Specialist":
    case "Tech Support":
    case "Transfer to Agent":
      i && !t ? n({ isSoluto: d, chatAction: "directTransfer" }) : a(i && t ? {
        source: "chatbot",
        content: "Sorry, Live tech support is not available at this time.",
        systemMessageFrom: "chatSupportOptionMsg"
      } : {
        source: "chatbot",
        content: "Sorry, you need to be logged in to Connect to our Agents.",
        systemMessageFrom: "chatSupportOptionMsg"
      });
      break;
    case "Direct to SR history":
    case "Resume my request submission":
    case "SR Cancel":
    case "Track my device delivery":
    case "Change my delivery address":
    case "Reschedule my current delivery":
    case "Submit Service Termination Request":
    case "Resume existing service request":
      (r = window.open(
        window.location.origin + "/swap/myplansandservicerequests",
        "_self",
        "referrer"
      )) == null || r.focus();
      break;
    case "Update Profile":
    case "Update Contact Details":
      (c = window.open(window.location.origin + "/profile", "_self", "referrer")) == null || c.focus();
      break;
    case "Help Article":
      (l = window.open(window.location.origin + "/portal/plan", "_self", "referrer")) == null || l.focus();
      break;
    case "Submit my request for Swap/Replacement device":
      (h = window.open(window.location.origin, "_self")) == null || h.focus();
      break;
    case "Submit Malfunction Request":
      (u = window.open(window.location.origin, "_self")) == null || u.focus();
      break;
    case "Check Swap/Replacement fee for my device":
      z(async () => {
        const C = await s();
        if (C && C.length === 0) {
          a({
            source: "chatbot",
            content: "The server encountered an error processing your request. Please try again, Sorry for the trouble.",
            systemMessageFrom: "chatSupportOptionMsg"
          }), a({
            source: "chatbot",
            content: "",
            systemMessageFrom: "chatAnswerQuestion"
          });
          return;
        }
        const w = C.reduce(
          (I, y, j) => j === 0 ? `Service request fee for ${y == null ? void 0 : y.serviceType} would be ${y == null ? void 0 : y.currencyCode} ${y == null ? void 0 : y.totalAmt}` : `${I}<br>Service request fee for ${y == null ? void 0 : y.serviceType} would be ${y == null ? void 0 : y.currencyCode} ${y == null ? void 0 : y.totalAmt}`,
          ""
        );
        a({
          source: "chatbot",
          content: w,
          systemMessageFrom: "chatSupportOptionMsg"
        }), a({
          source: "chatbot",
          content: "",
          systemMessageFrom: "chatAnswerQuestion"
        });
      }, 500);
      break;
    case "Submit my request for Swop/Replacement device":
      (x = window.open(window.location.origin, "_self")) == null || x.focus();
      break;
    case "Replacement device":
      (g = window.open(window.location.origin, "_self")) == null || g.focus();
      break;
    case "My device is damaged":
    case "My Screen is damaged":
      a({
        source: "chatbot",
        content: "We are sorry this has happened to you! You might want to try file a Repair or a Swap request from the Landing Page.",
        systemMessageFrom: "chatSupportOptionMsg"
      }), z(() => {
        a({
          source: "chatbot",
          content: "",
          systemMessageFrom: "chatAnswerQuestion"
        });
      }, 500);
      break;
    case "Start a Service Request":
      a({
        source: "chatbot",
        content: "Of course! Just click on the service request you would like from the Home Page"
      });
      break;
    case "Recommend article":
      (m = window.open(window.location.origin + "/articles/expert-tech-tips", "_blank", "referrer")) == null || m.focus();
      break;
    case "Link to the T&C page":
    case "Link to the FAQ page":
    case "Display Help Topics":
      (p = window.open(window.location.origin, "_blank", "referrer")) == null || p.focus();
      break;
  }
}, Uo = ({ message: o }) => {
  var y;
  const { data: i } = N(), { theme: t } = i, {
    components: { chat: n }
  } = t, { selectedDevice: a } = J(), { startLiveChat: s } = Te(), { handleAddMessageWithTimeout: d } = X(), { isLiveChatActive: r } = _(), { isLoggedIn: c } = ie(), { baseApiConfig: l, chatConfig: h } = B(), u = "pd", x = "data", [g] = Ue(u, { agreementId: "" }), { agreementId: m } = g || { agreementId: "" }, p = (a == null ? void 0 : a.agreementId) ?? m, [C] = Ue(x, "");
  let w = [];
  (y = o.systemMessage) == null || y.forEach(({ actionType: j }) => {
    typeof j == "string" && !w.includes(j) ? w.push(j) : Array.isArray(j) && (j == null || j.forEach((S) => {
      w.includes(S) || w.push(S);
    }));
  });
  const I = async () => (await Pt(
    l,
    p,
    C
  ) || []).map((S) => {
    var T, L;
    return {
      serviceType: S.IncidentType,
      totalAmt: (T = S.Fees) == null ? void 0 : T.TotalAmount,
      currencyCode: (L = S.Fees) == null ? void 0 : L.CurrencyCode
    };
  });
  return /* @__PURE__ */ e.jsxs(
    H,
    {
      className: "chatbot-node",
      p: 4,
      border: "1px",
      borderColor: "brand.neutral.deep",
      bg: "white",
      borderRadius: "lg",
      my: 4,
      children: [
        /* @__PURE__ */ e.jsx(G, { textAlign: "left", lineHeight: "19.84px", mb: 2, children: o.title ?? "Suggested options:" }),
        /* @__PURE__ */ e.jsx($, { flexFlow: "column nowrap", gap: 2, w: "full", mb: 2, children: w ? w.map((j) => /* @__PURE__ */ e.jsx(
          H,
          {
            w: "full",
            border: "1px",
            borderRadius: 8,
            borderColor: "primary.500",
            bgColor: n.surface,
            cursor: r ? "not-allowed" : "pointer",
            opacity: r ? 0.5 : 1,
            _hover: r ? {} : { border: "2px", borderColor: "primary.500" },
            onClick: () => {
              r || Bo({
                action: j,
                isLoggedIn: c,
                disableTechSupport: !!(h != null && h.disableTechSupport) || !!(h != null && h.disableChatbotTechSupport),
                onStartChat: s,
                onChatAssistClick: d,
                getOnlineServiceFees: I
              });
            },
            children: /* @__PURE__ */ e.jsx(
              G,
              {
                textAlign: "center",
                textColor: n.onSurface,
                fontWeight: "bold",
                p: 3,
                children: /* @__PURE__ */ e.jsx(
                  f,
                  {
                    text: j,
                    translationKey: `Global/chatAction-${j}`
                  }
                )
              }
            )
          },
          `actionBtn-${j}`
        )) : [] })
      ]
    }
  );
}, Ho = () => {
  var a;
  const { chatConfig: o } = B(), { data: i } = N(), { theme: t } = i, {
    components: { chat: n }
  } = t;
  return /* @__PURE__ */ e.jsx(k, { mr: "auto", mb: 3, className: "chatbot-node", children: /* @__PURE__ */ e.jsxs(M, { gap: 2, children: [
    /* @__PURE__ */ e.jsx(ue, { src: n.agentIcon, boxSize: "45px" }),
    /* @__PURE__ */ e.jsx(k, { bg: n.secondary, p: 3, borderRadius: 8, children: /* @__PURE__ */ e.jsx(
      v,
      {
        sx: {
          "ol li": {
            listStylePos: "inside"
          }
        },
        fontWeight: "bold",
        color: n.onSecondary,
        px: 2,
        children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: ((a = o == null ? void 0 : o.flow) == null ? void 0 : a.messageIfAgentsUnavailable) ?? "Thank you for contacting us. All our agents are currently unavailable. You can reach us after some time or alternatively submit an inquiry.",
            translationKey: "Global/chatAgentsUnavailableMessage"
          }
        )
      }
    ) })
  ] }) });
}, Ko = () => {
  const { language: o, getTextScript: i } = he(), t = me(), { addMessage: n } = X(), { handleEndChatSession: a } = oe(), { data: s } = N(), { theme: d } = s, {
    components: { chat: r }
  } = d, c = async () => {
    const h = await i("Global/chatOnClickNo", "No", o);
    n({
      source: "user",
      content: h
    }), z(() => {
      a();
    }, 2e3);
  }, l = async () => {
    const h = await i("Global/chatOnClickYes", "Yes", o);
    n({
      source: "user",
      content: h
    }), z(() => {
      n({
        source: "chatbot",
        content: "",
        systemMessageFrom: "chatDialogCallback"
      });
    }, 1e3);
  };
  return /* @__PURE__ */ e.jsxs(
    k,
    {
      p: 4,
      border: "1px solid",
      borderColor: "brand.border",
      borderRadius: 8,
      bg: "white",
      w: "full",
      mb: 4,
      children: [
        /* @__PURE__ */ e.jsx(v, { mb: 4, children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: "Would you like us to give you a callback?",
            translationKey: `Global/chatDialogQuestion-${t}-callbackQuestion`
          }
        ) }),
        /* @__PURE__ */ e.jsx(M, { justify: "space-between", align: "center", children: /* @__PURE__ */ e.jsxs(Le, { columns: 2, spacing: 4, w: "full", children: [
          /* @__PURE__ */ e.jsx(
            se,
            {
              border: "1px solid",
              borderColor: "brand.neutral.deep",
              borderRadius: 8,
              px: 5,
              py: 3,
              cursor: "pointer",
              bgColor: r.surface,
              color: r.onSurface,
              _hover: {
                border: "2px",
                borderColor: "black"
              },
              onClick: c,
              children: /* @__PURE__ */ e.jsx(f, { text: "No", translationKey: "Global/chatDialogNo" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            se,
            {
              border: "1px solid",
              borderColor: "brand.neutral.deep",
              borderRadius: 8,
              px: 5,
              py: 3,
              cursor: "pointer",
              bgColor: r.surface,
              color: r.onSurface,
              _hover: {
                border: "2px",
                borderColor: "black"
              },
              onClick: l,
              children: /* @__PURE__ */ e.jsx(f, { text: "Yes", translationKey: "Global/chatDialogYes" })
            }
          )
        ] }) })
      ]
    }
  );
}, $o = () => {
  var u, x;
  const { language: o, getTextScript: i } = he(), { chatConfig: t } = B(), { deviceList: n, setSelectedDevice: a } = J(), { handleAddMessageWithTimeout: s } = X(), { data: d } = N(), { theme: r } = d, {
    components: { chat: c }
  } = r, l = ((u = t == null ? void 0 : t.flow) == null ? void 0 : u.chatSupportInfo) ?? xt, h = n || Ge(((x = t == null ? void 0 : t.flow) == null ? void 0 : x.deviceSelectionKey) ?? "deviceOptions");
  return /* @__PURE__ */ e.jsx(
    k,
    {
      p: 4,
      border: "1px",
      borderColor: "brand.neutral.deep",
      bg: "white",
      borderRadius: "lg",
      mb: 4,
      className: "chatbot-node",
      children: /* @__PURE__ */ e.jsxs(Ie, { spacing: 4, children: [
        /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", gap: 1, w: "full", children: [
          /* @__PURE__ */ e.jsx(v, { fontSize: "xl", fontWeight: "light", textAlign: "left", lineHeight: "26.4px", children: "Which device are you inquiring for?" }),
          /* @__PURE__ */ e.jsx(v, { textAlign: "left", lineHeight: "19.84px", children: "Please select your device below" })
        ] }),
        /* @__PURE__ */ e.jsx(M, { flexFlow: "column nowrap", gap: 2, w: "full", children: h == null ? void 0 : h.map((g, m) => /* @__PURE__ */ e.jsx(
          k,
          {
            w: "full",
            border: "1px",
            borderRadius: 8,
            borderColor: "primary.500",
            cursor: "pointer",
            _hover: { border: "2px", borderColor: "primary.500" },
            bgColor: c.surface,
            onClick: async () => {
              a(g);
              const p = await i(
                "Global/chatDeviceSelectedPrefix",
                "Selected",
                o
              );
              s({
                source: "user",
                content: `${p} "${g.catalogName}"`
              }), z(() => {
                l.selection.map((C) => {
                  t != null && t.disableTechSupport && (t != null && t.disableChatbotTechSupport) && C.title === "Tech Support" || t != null && t.disableGeneralInquiry && C.title === "General Inquiries" || s({
                    source: "chatbot",
                    title: C.title,
                    content: C.description,
                    systemMessageFrom: "chatIntroSelection"
                  });
                });
              }, 500);
            },
            children: /* @__PURE__ */ e.jsx(
              v,
              {
                textAlign: "center",
                textColor: c.onSurface,
                fontWeight: "bold",
                py: 3,
                px: 1,
                children: g.catalogName
              }
            )
          },
          `inquiryBtn-${m}`
        )) })
      ] })
    }
  );
}, _o = () => {
  const [o] = Ne({
    profileId: "",
    userId: "",
    requestId: "",
    visitorId: ""
  }), { language: i, getTextScript: t } = he(), n = me(), { userInfo: a } = ie(), { chatConfig: s, baseApiConfig: d } = B(), { setIsCallbackInputActive: r } = _(), { addMessage: c } = X(), { handleEndChatSession: l } = oe(), { data: h } = N(), { theme: u } = h, {
    components: { chat: x }
  } = u, g = async () => {
    const p = await t(
      "Global/chatCallbackOnClickNo",
      "No, please type another mobile number",
      i
    );
    c({
      source: "user",
      content: p
    }), r(!0);
  }, m = async () => {
    const p = await t("Global/chatOnClickYes", "Yes", i);
    c({
      source: "user",
      content: p
    }), z(async () => {
      var C;
      c({
        source: "agent",
        content: ((C = s == null ? void 0 : s.callback) == null ? void 0 : C.callbackResponse) ?? "Our Tech Specialist will contact you next 2 business days during operating hours. Thank you."
      });
    }, 1e3), z(async () => {
      await Xe(d, {
        mdn: a.mdn,
        name: a.name
      }), l();
    }, 3e3);
  };
  return /* @__PURE__ */ e.jsxs(
    k,
    {
      p: 4,
      border: "1px solid",
      borderColor: "brand.border",
      borderRadius: 8,
      bg: "white",
      w: "full",
      mb: 4,
      children: [
        /* @__PURE__ */ e.jsx(v, { mb: 4, children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: "Would you like us to call you in this mobile number?",
            translationKey: `Global/chatDialogCallbackQuestion-${n}-1`
          }
        ) }),
        /* @__PURE__ */ e.jsx(v, { children: "Preferred Contact Number" }),
        /* @__PURE__ */ e.jsx(v, { fontWeight: 600, mb: 4, children: o.enrolledMdn }),
        /* @__PURE__ */ e.jsx(M, { justify: "space-between", align: "center", children: /* @__PURE__ */ e.jsxs(Le, { columns: 2, spacing: 4, w: "full", children: [
          /* @__PURE__ */ e.jsx(
            se,
            {
              border: "1px solid",
              borderColor: "brand.neutral.deep",
              borderRadius: 8,
              px: 5,
              py: 3,
              cursor: "pointer",
              bgColor: x.surface,
              color: x.onSurface,
              _hover: {
                border: "2px",
                borderColor: "black"
              },
              onClick: g,
              children: /* @__PURE__ */ e.jsx(f, { text: "No", translationKey: "Global/chatDialogNo" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            se,
            {
              border: "1px solid",
              borderColor: "brand.neutral.deep",
              borderRadius: 8,
              px: 5,
              py: 3,
              cursor: "pointer",
              bgColor: x.surface,
              color: x.onSurface,
              _hover: {
                border: "2px",
                borderColor: "black"
              },
              onClick: m,
              children: /* @__PURE__ */ e.jsx(f, { text: "Yes", translationKey: "Global/chatDialogYes" })
            }
          )
        ] }) })
      ]
    }
  );
}, Qo = ({ chatSupportFAQ: o }) => {
  var u;
  const { isLiveChatActive: i } = _(), { data: t } = N(), { theme: n } = t, {
    components: { chat: a }
  } = n, { handleUserMessageChatbot: s } = ve(), d = me(), { chatConfig: r } = B(), l = ((x, g) => {
    var p, C;
    const m = (C = o.items) == null ? void 0 : C.filter(
      (w) => {
        var I;
        return ((I = w == null ? void 0 : w.fields) == null ? void 0 : I.chatSupport.toLowerCase()) === x.toLowerCase();
      }
    ).map(
      (w) => {
        var I;
        return (I = w == null ? void 0 : w.fields) == null ? void 0 : I.subcategory;
      }
    ).sort(
      (p = r == null ? void 0 : r.chatBot) != null && p.genInqSortArray ? (w, I) => (r == null ? void 0 : r.chatBot.genInqSortArray.indexOf(w)) - (r == null ? void 0 : r.chatBot.genInqSortArray.indexOf(I)) : void 0
    );
    return {
      title: x,
      description: g,
      options: m
    };
  })(
    "General Inquiries",
    "Please select your inquiry below"
  ), h = ((u = l.options) == null ? void 0 : u.length) > 0 ? l : Co;
  return /* @__PURE__ */ e.jsx(
    H,
    {
      p: 4,
      border: "1px",
      borderColor: "brand.neutral.deep",
      bg: "white",
      borderRadius: "lg",
      mb: 4,
      className: "chatbot-node",
      children: /* @__PURE__ */ e.jsxs(rt, { spacing: 4, children: [
        /* @__PURE__ */ e.jsxs($, { flexFlow: "column nowrap", gap: 1, w: "full", children: [
          /* @__PURE__ */ e.jsx(G, { fontSize: "xl", fontWeight: "light", textAlign: "left", lineHeight: "26.4px", children: /* @__PURE__ */ e.jsx(
            f,
            {
              text: h.title,
              translationKey: `Global/chatSupportOptionTitle-${d}-${h.title}`
            }
          ) }),
          /* @__PURE__ */ e.jsx(G, { textAlign: "left", lineHeight: "19.84px", children: /* @__PURE__ */ e.jsx(
            f,
            {
              text: h.description,
              translationKey: `Global/chatSupportOptionDesc-${d}-${h.title}`
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx($, { flexFlow: "column nowrap", gap: 2, w: "full", children: h.options.map((x, g) => /* @__PURE__ */ e.jsx(
          H,
          {
            w: "full",
            border: "1px",
            borderRadius: 8,
            borderColor: "primary.500",
            bgColor: a.surface,
            cursor: i ? "not-allowed" : "pointer",
            opacity: i ? "40%" : "100%",
            _hover: i ? {} : { border: "2px", borderColor: "primary.500" },
            onClick: () => {
              i || s(x, !0);
            },
            children: /* @__PURE__ */ e.jsx(
              G,
              {
                textAlign: "center",
                textColor: a.onSurface,
                fontWeight: "bold",
                py: 3,
                px: 1,
                children: /* @__PURE__ */ e.jsx(
                  f,
                  {
                    text: x,
                    translationKey: `Global/chatSupportOptionInfo-${d}-${h.title}-${g}`
                  }
                )
              }
            )
          },
          `${x}-${g}`
        )) })
      ] })
    }
  );
}, Vo = {
  title: "Please select one of the following options",
  selection: [
    {
      inquiryType: "deviceCareInquiry",
      title: "I need help with my mobile device and gadgets",
      description: "Get help for your mobile device, laptop, smartwatch, gaming console, wireless earphones or headphones"
    },
    {
      inquiryType: "homeInsuranceInquiry",
      title: "I need help with my Home devices",
      description: "SmartSupport Home devices include the Refrigerator, Robot Vacuum and many more"
    }
  ]
}, Yo = () => {
  var g;
  const { language: o, getTextScript: i } = he(), { chatConfig: t } = B(), { deviceList: n } = J(), { isLiveChatActive: a } = _(), { addMessage: s } = X(), { data: d } = N(), { theme: r } = d, {
    components: { chat: c }
  } = r, [l, h] = q(!1), u = l || a, x = n || Ge(((g = t == null ? void 0 : t.flow) == null ? void 0 : g.deviceSelectionKey) ?? "deviceOptions");
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: Vo.selection.map(({ inquiryType: m, title: p, description: C }) => /* @__PURE__ */ e.jsx(k, { className: "chatbot-node", children: /* @__PURE__ */ e.jsx(Ie, { spacing: 4, my: 2, children: /* @__PURE__ */ e.jsxs(
    k,
    {
      role: "button",
      w: "full",
      p: 4,
      borderRadius: "lg",
      border: "1px",
      borderColor: "brand.neutral.deep",
      bgColor: c.surface,
      color: c.onSurface,
      cursor: u ? "not-allowed" : "pointer",
      opacity: u ? "70%" : "100%",
      _hover: u ? {} : {
        transition: "all .2s ease-in",
        border: "2px",
        borderColor: "brand.black",
        "& p": {
          transition: "all .2s ease-in",
          fontWeight: "bold"
        }
      },
      onClick: async () => {
        if (h(!0), u)
          return;
        const w = await i(
          `Global/chatInquiryTypeSelection-${p}`,
          p,
          o
        );
        s({
          source: "user",
          content: w
        }), z(() => {
          m === "deviceCareInquiry" ? x ? s({
            source: "chatbot",
            content: "",
            systemMessageFrom: "chatDeviceSelection"
          }) : (s({
            source: "chatbot",
            content: "",
            systemMessageFrom: "chatNoDevicesFound"
          }), z(() => {
            s({
              source: "chatbot",
              content: "",
              systemMessageFrom: "chatInquiryTypeSelection"
            });
          }, 500)) : m === "homeInsuranceInquiry" && alert("home insurance selected");
        }, 500);
      },
      children: [
        /* @__PURE__ */ e.jsx(v, { fontSize: "xl", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: p,
            translationKey: `Global/chatInquiryType-title-${p}`
          }
        ) }),
        /* @__PURE__ */ e.jsx(v, { fontSize: "md", fontWeight: "normal", children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: C,
            translationKey: `Global/chatInquiryType-desciption-${p}`
          }
        ) })
      ]
    },
    `inquiry-type-${p}`
  ) }) }, m)) });
}, Jo = ({ message: o }) => {
  const { language: i, getTextScript: t } = he(), { chatConfig: n } = B(), { setChatInputStatus: a, isLiveChatActive: s } = _(), { handleAddMessageWithTimeout: d } = X(), { data: r } = N(), { theme: c } = r, {
    components: { chat: l }
  } = c;
  return /* @__PURE__ */ e.jsx(k, { className: "chatbot-node", children: /* @__PURE__ */ e.jsx(Ie, { spacing: 4, my: 2, children: /* @__PURE__ */ e.jsxs(
    k,
    {
      role: "button",
      w: "full",
      p: 4,
      borderRadius: "lg",
      border: "1px",
      borderColor: "brand.neutral.deep",
      bgColor: l.surface,
      color: l.onSurface,
      cursor: s ? "not-allowed" : "pointer",
      opacity: s ? "70%" : "100%",
      _hover: s ? {} : {
        transition: "all .2s ease-in",
        border: "2px",
        borderColor: "brand.black",
        "& p": {
          transition: "all .2s ease-in",
          fontWeight: "bold"
        }
      },
      onClick: async () => {
        if (!s) {
          if ((o == null ? void 0 : o.title) === "General Inquiries") {
            const h = await t(
              `Global/chatIntroSelection-${o == null ? void 0 : o.title}`,
              o == null ? void 0 : o.title,
              i
            );
            d({
              source: "user",
              content: h
            }), d({
              source: "chatbot",
              content: o == null ? void 0 : o.title,
              systemMessageFrom: "chatSupportOption"
            }), a(K.Disabled);
            return;
          }
          if ((o == null ? void 0 : o.title) === "Tech Support") {
            const h = await t(
              `Global/chatIntroSelection-${o == null ? void 0 : o.title}`,
              "Could you please provide some details about the issue you're facing?",
              i
            ), u = !(n != null && n.disableTechSupport);
            !(n != null && n.disableChatbotTechSupport) ? (console.debug("Chatbot Tech Support selected"), a(K.TechSupportChatbotInput), d({
              source: "chatbot",
              content: h,
              systemMessageFrom: "chatSupportOptionMsg"
            })) : u && (console.debug("Live Agent Tech Support selected"), a(K.TechSupportInput), d({
              source: "chatbot",
              content: h,
              systemMessageFrom: "chatSupportOptionMsg"
            }));
          }
        }
      },
      children: [
        /* @__PURE__ */ e.jsx(v, { fontSize: "xl", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: (o == null ? void 0 : o.title) ?? "",
            translationKey: `Global/chatSupportTitle-${o == null ? void 0 : o.title}`
          }
        ) }),
        /* @__PURE__ */ e.jsx(v, { fontSize: "md", fontWeight: "normal", children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: o.content,
            translationKey: `Global/chatSupportDesc-${o == null ? void 0 : o.title}`
          }
        ) })
      ]
    },
    `info-${o == null ? void 0 : o.title}`
  ) }) });
}, Xo = () => {
  var c;
  const o = st(), { chatConfig: i } = B(), { data: t } = N(), { theme: n } = t, {
    components: { chat: a }
  } = n, s = o.getQueryData(["getChatSchedule"]), d = Ot(
    (i == null ? void 0 : i.chat.businessOpen) ?? "8",
    (i == null ? void 0 : i.chat.businessClose) ?? "24"
  );
  let r;
  return (c = i == null ? void 0 : i.flow) != null && c.messageIfNoLiveChat ? r = i.flow.messageIfNoLiveChat.replace(
    "{{businessHours}}",
    (s == null ? void 0 : s.friendlyName) ?? d
  ) : r = `Live chat is currently closed, but we want to ensure
        you get the help you need. You can contact us again
        between {{businessHours}} or raise an enquiry and we'll get back
        to you as soon as possible.`.replace(
    "{{businessHours}}",
    (s == null ? void 0 : s.friendlyName) ?? d
  ), /* @__PURE__ */ e.jsx(k, { mr: "auto", mb: 3, className: "chatbot-node", children: /* @__PURE__ */ e.jsxs(M, { gap: 2, children: [
    /* @__PURE__ */ e.jsx(ue, { src: a.agentIcon, boxSize: "45px" }),
    /* @__PURE__ */ e.jsx(k, { bg: a.secondary, p: 3, borderRadius: 8, children: /* @__PURE__ */ e.jsx(
      v,
      {
        sx: {
          "ol li": {
            listStylePos: "inside"
          }
        },
        fontWeight: "bold",
        color: a.onSecondary,
        px: 2,
        children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: r,
            translationKey: `Global/chatOutOfOfficeMessage_${(s == null ? void 0 : s.friendlyName) ?? d}`
          }
        )
      }
    ) })
  ] }) });
}, Zo = () => {
  const { handleEndChatSession: o } = oe(), { data: i } = N(), { theme: t } = i, {
    components: { chat: n }
  } = t;
  return /* @__PURE__ */ e.jsxs(
    k,
    {
      className: "chatbot-node",
      p: 4,
      border: "1px",
      borderColor: "brand.neutral.deep",
      bg: "white",
      borderRadius: "lg",
      my: 4,
      children: [
        /* @__PURE__ */ e.jsx(v, { textAlign: "left", lineHeight: "19.84px", mb: 2, children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: "Submit an Inquiry",
            translationKey: "Global/chatSupportOptionSubmitAnInquiry"
          }
        ) }),
        /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", gap: 2, w: "full", mb: 2, children: [
          /* @__PURE__ */ e.jsx(
            k,
            {
              w: "full",
              border: "1px",
              borderRadius: 8,
              borderColor: "primary.500",
              cursor: "pointer",
              _hover: { border: "2px", borderColor: "primary.500" },
              bgColor: n.surface,
              onClick: () => {
                var a;
                return (a = window.open(window.location.origin + "/inquiry", "_self")) == null ? void 0 : a.focus();
              },
              children: /* @__PURE__ */ e.jsx(
                v,
                {
                  textAlign: "center",
                  textColor: n.onSurface,
                  fontWeight: "bold",
                  p: 3,
                  children: /* @__PURE__ */ e.jsx(
                    f,
                    {
                      text: "Submit an Inquiry",
                      translationKey: "Global/chatSupportOptionSubmitAnEnquiry"
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            k,
            {
              w: "full",
              border: "1px",
              borderRadius: 8,
              borderColor: "primary.500",
              cursor: "pointer",
              _hover: { border: "2px", borderColor: "primary.500" },
              bgColor: n.surface,
              onClick: o,
              children: /* @__PURE__ */ e.jsx(
                v,
                {
                  textAlign: "center",
                  textColor: n.onSurface,
                  fontWeight: "bold",
                  p: 3,
                  children: /* @__PURE__ */ e.jsx(
                    f,
                    {
                      text: "Leave Chat",
                      translationKey: "Global/chatSupportEnquiryLeaveChat"
                    }
                  )
                }
              )
            }
          )
        ] })
      ]
    }
  );
}, en = ({ message: o }) => {
  var d;
  const { data: i } = N(), { theme: t } = i, {
    components: { chat: n }
  } = t, a = me(), { handleAddMessageWithTimeout: s } = X();
  return /* @__PURE__ */ e.jsxs(
    H,
    {
      className: "chatbot-node",
      p: 4,
      border: "1px",
      borderColor: "brand.neutral.deep",
      bg: "white",
      borderRadius: "lg",
      mb: 4,
      children: [
        /* @__PURE__ */ e.jsx(G, { textAlign: "left", lineHeight: "19.84px", mb: 2, children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: "Please choose from the options below or type your own inquiry:",
            translationKey: `Global/chatChoosInquiry-${a}`
          }
        ) }),
        (d = o.systemMessage) == null ? void 0 : d.map(({ suggestionList: r, content: c }, l) => /* @__PURE__ */ e.jsx($, { flexFlow: "column nowrap", gap: 2, w: "full", mb: 2, children: r.map((h, u) => /* @__PURE__ */ e.jsx(
          H,
          {
            w: "full",
            border: "1px",
            borderRadius: 8,
            borderColor: "primary.500",
            cursor: "pointer",
            _hover: { border: "2px", borderColor: "primary.500" },
            bgColor: n.surface,
            onClick: async () => {
              s({
                source: "chatbot",
                content: c,
                systemMessageFrom: "chatSupportOptionMsg"
              }), z(
                () => s({
                  source: "chatbot",
                  content: c,
                  systemMessageFrom: "chatBotContentAction",
                  systemMessage: o.systemMessage
                }),
                500
              ), z(() => {
                s({
                  source: "chatbot",
                  content: "",
                  systemMessageFrom: "chatAnswerQuestion"
                });
              }, 1e3);
            },
            children: /* @__PURE__ */ e.jsx(
              G,
              {
                textAlign: "center",
                textColor: n.onSurface,
                fontWeight: "bold",
                p: 3,
                children: h
              }
            )
          },
          `suggestionBtn-${u}`
        )) }, `${l}-suggestList`))
      ]
    }
  );
}, tn = () => {
  const { data: o } = N(), { theme: i } = o, {
    components: { chat: t }
  } = i, { messages: n } = X(), { handleResetIdleTimeout: a } = Re(), { userInfo: s } = ie(), { chatStatus: d, showIdleMessage: r } = _(), { isTyping: c } = J(), l = je.useRef(null), [h, u] = je.useState(!0), x = [O.Connected, O.Transferred].includes(d), { isAuthenticated: g } = Ye(), m = me(), { chatConfig: p, firebaseConfig: C } = B(), { contentfulEntry: w, contentfulEntryLoading: I } = So(
    {
      select: "fields",
      "fields.carrier": m
    },
    "chatFaq",
    p == null ? void 0 : p.contentful.space,
    p == null ? void 0 : p.contentful.token,
    p == null ? void 0 : p.contentful.env,
    C
  );
  return je.useEffect(() => {
    if (g() && !x) {
      const y = n.at(-1);
      if (n.length === 0) {
        He("chatbot").then(async (j) => {
          if (j && j != "data:,") {
            const S = Fe(
              j,
              s.visitorId,
              "",
              y == null ? void 0 : y.source,
              "user",
              "canvas"
            );
            await Q.createChatMessage(S);
          }
        }), u(!1);
        return;
      }
      if (y)
        if (y.source === "chatbot")
          He("chatbot").then(async (j) => {
            if (j && j != "data:,") {
              const S = Fe(
                j,
                s.visitorId,
                "",
                y.source,
                "user",
                "canvas"
              );
              await Q.createChatMessage(S);
            }
          });
        else {
          const j = Fe(y.content, s.visitorId, "");
          (async () => {
            await Q.createChatMessage(j);
          })();
        }
      z(() => {
        u(!1);
      }, 500);
    }
  }, [n]), je.useEffect(() => {
    l.current && l.current.scrollTo(0, l.current.scrollHeight + 100);
  }, [n, r, c, h]), /* @__PURE__ */ e.jsxs(
    M,
    {
      p: 4,
      flex: 1,
      ref: l,
      w: "full",
      bg: t.background,
      flexFlow: "column nowrap",
      overflowY: "auto",
      scrollBehavior: "smooth",
      children: [
        !x && (!I && !h ? /* @__PURE__ */ e.jsx(e.Fragment, { children: n.map((y, j) => /* @__PURE__ */ e.jsx(
          Qe,
          {
            message: y,
            chatSupportFAQ: w
          },
          j
        )) }) : /* @__PURE__ */ e.jsx(se, { h: "full", children: /* @__PURE__ */ e.jsx(et, { color: t.onBackground }) })),
        x && /* @__PURE__ */ e.jsx(e.Fragment, { children: n.map((y, j) => /* @__PURE__ */ e.jsx(
          Qe,
          {
            message: y,
            chatSupportFAQ: w
          },
          j
        )) }),
        r && /* @__PURE__ */ e.jsx(No, { handleResetIdleTimeout: a }),
        c && /* @__PURE__ */ e.jsx(Wo, {})
      ]
    }
  );
}, Qe = ({
  message: o,
  chatSupportFAQ: i
}) => {
  const { data: t } = N(), { theme: n } = t, {
    components: { chat: a }
  } = n, s = o.source.toLocaleLowerCase();
  return s === "agent" ? /* @__PURE__ */ e.jsx(k, { mr: "auto", mb: 3, children: /* @__PURE__ */ e.jsxs(M, { gap: 2, children: [
    /* @__PURE__ */ e.jsx(ue, { src: a.agentIcon, boxSize: "45px" }),
    /* @__PURE__ */ e.jsx(k, { bg: a.secondary, p: 3, borderRadius: 8, children: /* @__PURE__ */ e.jsx(
      v,
      {
        fontWeight: "bold",
        color: a.onSecondary,
        px: 2,
        whiteSpace: "pre-line",
        wordBreak: "break-word",
        children: o.content
      }
    ) })
  ] }) }) : s === "user" ? /* @__PURE__ */ e.jsx(k, { ml: "auto", mb: 3, children: /* @__PURE__ */ e.jsx(
    k,
    {
      bg: "white",
      p: 3,
      borderRadius: 8,
      border: "1px",
      borderColor: "brand.neutral.deep",
      children: /* @__PURE__ */ e.jsx(v, { fontWeight: "bold", whiteSpace: "pre-line", wordBreak: "break-word", children: o.content })
    }
  ) }) : /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(on, { message: o, chatSupportFAQ: i }) });
}, on = ({
  message: o,
  chatSupportFAQ: i
}) => {
  const { handleAddMessageWithTimeout: t } = X(), { handleChatDialogYesAction: n, handleChatDialogNoAction: a } = ve(), { handleEndChatSession: s } = oe(), { data: d } = N(), { theme: r } = d, {
    components: { chat: c }
  } = r;
  switch (o.systemMessageFrom) {
    case "chatInquiryTypeSelection":
      return /* @__PURE__ */ e.jsx(Yo, {});
    case "chatIntroSelection":
      return /* @__PURE__ */ e.jsx(Jo, { message: o });
    case "chatBotSuggestion":
      return /* @__PURE__ */ e.jsx(en, { message: o });
    case "chatSupportOptionMsg":
      return /* @__PURE__ */ e.jsx(k, { mr: "auto", mb: 3, className: "chatbot-node", children: /* @__PURE__ */ e.jsxs(M, { gap: 2, children: [
        /* @__PURE__ */ e.jsx(ue, { src: c.agentIcon, boxSize: "45px" }),
        /* @__PURE__ */ e.jsx(k, { bg: c.secondary, p: 3, borderRadius: 8, children: /* @__PURE__ */ e.jsx(
          v,
          {
            sx: {
              "ol li": {
                listStylePos: "inside"
              }
            },
            fontWeight: "bold",
            color: c.onSecondary,
            px: 2,
            dangerouslySetInnerHTML: { __html: o.content },
            whiteSpace: "pre-wrap"
          }
        ) })
      ] }) });
    case "chatAnswerQuestion":
      return /* @__PURE__ */ e.jsx(
        Oe,
        {
          question: "Did we answer your question?",
          onClickYes: n,
          onClickNo: a
        }
      );
    case "chatOtherInquiriesQuestion":
      return /* @__PURE__ */ e.jsx(
        Oe,
        {
          question: "Do you have any other inquiries?",
          customTranslationKey: "chatDialogOtherInquires",
          onClickYes: () => {
            t({
              source: "chatbot",
              content: "General Inquiries",
              systemMessageFrom: "chatSupportOption"
            });
          },
          onClickNo: s
        }
      );
    case "chatBotContentAction":
      return /* @__PURE__ */ e.jsx(Uo, { message: o });
    case "chatServiceRequest":
      return /* @__PURE__ */ e.jsx(Go, { message: o });
    case "chatSubmitAnEnquiry":
      return /* @__PURE__ */ e.jsx(Zo, {});
    case "chatDeviceSelection":
      return /* @__PURE__ */ e.jsx($o, {});
    case "chatOutOfOfficeMsg":
      return /* @__PURE__ */ e.jsx(Xo, {});
    case "chatAgentsUnavailableMsg":
      return /* @__PURE__ */ e.jsx(Ho, {});
    case "chatDialogQuestion":
      return /* @__PURE__ */ e.jsx(Ko, {});
    case "chatDialogCallback":
      return /* @__PURE__ */ e.jsx(_o, {});
    case "chatConnectedToAgent":
      return /* @__PURE__ */ e.jsxs(M, { alignItems: "center", color: "gray", gap: "7px", py: "10px", children: [
        /* @__PURE__ */ e.jsx(k, { borderTop: "1px", w: "100%" }),
        /* @__PURE__ */ e.jsx(v, { fontSize: "small", width: "max-content", whiteSpace: "nowrap", children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: "You are now connected to an agent.",
            translationKey: "Global/chatConnectedToAgent"
          }
        ) }),
        /* @__PURE__ */ e.jsx(k, { borderTop: "1px", w: "100%" })
      ] });
    case "chatNoDevicesFound":
      return /* @__PURE__ */ e.jsx(k, { mr: "auto", mb: 3, className: "chatbot-node", children: /* @__PURE__ */ e.jsxs(M, { gap: 2, children: [
        /* @__PURE__ */ e.jsx(ue, { src: c.agentIcon, boxSize: "45px" }),
        /* @__PURE__ */ e.jsx(k, { bg: c.secondary, p: 3, borderRadius: 8, children: /* @__PURE__ */ e.jsx(
          v,
          {
            sx: {
              "ol li": {
                listStylePos: "inside"
              }
            },
            fontWeight: "bold",
            color: c.onSecondary,
            px: 2,
            children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: "There are no devices found.  Please try again later, Sorry for the trouble.",
                translationKey: "Global/chatNoDevicesFound"
              }
            )
          }
        ) })
      ] }) });
    case "chatStartMessage":
      return /* @__PURE__ */ e.jsx(k, { mr: "auto", mb: 3, className: "chatbot-node", children: /* @__PURE__ */ e.jsxs(M, { gap: 2, children: [
        /* @__PURE__ */ e.jsx(ue, { src: c.agentIcon, boxSize: "45px" }),
        /* @__PURE__ */ e.jsx(k, { bg: c.secondary, p: 3, borderRadius: 8, children: /* @__PURE__ */ e.jsx(
          v,
          {
            sx: {
              "ol li": {
                listStylePos: "inside"
              }
            },
            fontWeight: "bold",
            color: c.onSecondary,
            px: 2,
            children: /* @__PURE__ */ e.jsx(
              f,
              {
                text: o.content,
                translationKey: "Global/chatStartMessage"
              }
            )
          }
        ) })
      ] }) });
    default:
      return /* @__PURE__ */ e.jsx(Qo, { chatSupportFAQ: i });
  }
}, nn = () => {
  var y, j;
  const { chatConfig: o } = B(), { chatRequestId: i } = J(), { terminateChat: t } = oe(), [n, a] = q(), [s, d] = q(0), [r, c] = q(0), l = (S, T) => {
    a(
      (L) => {
        var U;
        return L != null && L.find((A) => A.QuestionId === S) ? L.map(
          (A) => A.QuestionId === S ? {
            QuestionId: S,
            Answer: T,
            QuestionType: A.QuestionType
          } : A
        ) : [
          ...L || [],
          {
            QuestionId: S,
            Answer: T,
            QuestionType: (U = m == null ? void 0 : m.find((A) => A.QuestionId === S)) == null ? void 0 : U.QuestionType
          }
        ];
      }
    );
  }, h = async () => {
    var S;
    if (I) {
      t();
      return;
    }
    if (w) {
      Lt(
        o,
        {
          SubmitSurveyAnswers: {
            SurveyId: (m == null ? void 0 : m[0].SurveyId) ?? "",
            ClientId: ((S = o == null ? void 0 : o.chatSurvey) == null ? void 0 : S.surveyClientId) ?? "",
            CustomerCaseNumber: "",
            EngagementId: i ?? "",
            Results: n ?? []
          }
        }
      ), c(-1);
      return;
    }
    c(r + 1);
  }, {
    data: u,
    isLoading: x,
    isError: g
  } = De({
    queryKey: [
      "getChatSurvey",
      o == null ? void 0 : o.chat.clientName,
      (y = o == null ? void 0 : o.chatSurvey) == null ? void 0 : y.surveyTriggerPoint
    ],
    queryFn: () => Je(o),
    staleTime: 0,
    refetchOnMount: !1
  }), m = u == null ? void 0 : u.map((S) => ({
    ...S,
    DisplayOrder: parseInt(S.DisplayOrder)
  })).sort((S, T) => S.DisplayOrder - T.DisplayOrder), p = Object.values(
    (m == null ? void 0 : m.reduce(
      (S, T) => (S[T.DisplayOrder] = [...S[T.DisplayOrder] || [], T], S),
      {}
    )) ?? {}
  ), C = ((j = p == null ? void 0 : p[r]) == null ? void 0 : j.some((S) => S.QuestionOptions === "option")) && !(n != null && n.find((S) => {
    var T;
    return S.QuestionId === ((T = m == null ? void 0 : m[r]) == null ? void 0 : T.QuestionId) && S.Answer;
  })), w = p.length - 1 === r, I = r === -1;
  return {
    groupedQuestions: p,
    isSurveyDataLoading: x,
    isSurveyFetchErrored: g,
    isLastPage: w,
    isFormSubmitted: I,
    formState: n,
    updateFormValue: l,
    npsValue: s,
    setNpsValue: d,
    page: r,
    isSubmitDisabled: C,
    handleNavigationClick: h
  };
}, sn = () => /* @__PURE__ */ e.jsxs(M, { direction: "column", gap: "10px", h: "full", py: "20%", px: 4, children: [
  /* @__PURE__ */ e.jsx(wo, { width: "80x", height: "90px" }),
  /* @__PURE__ */ e.jsx(
    v,
    {
      align: "center",
      fontSize: "3xl",
      fontWeight: "light",
      letterSpacing: "-0.352px",
      lineHeight: "39.68px",
      children: /* @__PURE__ */ e.jsx(
        f,
        {
          text: "Thanks for your feedback",
          translationKey: "Global/chatNPSEndFeedbackHeader"
        }
      )
    }
  ),
  /* @__PURE__ */ e.jsx(v, { fontSize: "xl", align: "center", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
    f,
    {
      text: "Your feedback is a huge part of improving the experience.",
      translationKey: "Global/chatNPSEndFeedbackDescription"
    }
  ) })
] });
var bt = /* @__PURE__ */ ((o) => (o.PROMOTER = "PROMOTER", o.PASSIVE = "PASSIVE", o.DETRACTOR = "DETRACTOR", o))(bt || {});
const rn = ({
  label: o,
  formState: i,
  questionId: t,
  setUpdateFormValue: n,
  optionString: a,
  questionType: s
}) => {
  var u;
  const [d, r] = q([]), c = me();
  let l;
  s.toUpperCase() in bt ? l = Nt(c)[s.toUpperCase()] ?? Wt[s.toUpperCase()] : l = a == null ? void 0 : a.split(":"), ee(() => {
    n(t, d.join(", "));
  }, [d]);
  const h = (u = i == null ? void 0 : i.find((x) => x.QuestionId === t)) == null ? void 0 : u.Answer;
  return s.toUpperCase() == "RESOLUTION" ? /* @__PURE__ */ e.jsxs(M, { direction: "column", py: "25px", gap: "20px", alignItems: "center", children: [
    /* @__PURE__ */ e.jsx(v, { fontSize: "large", as: "label", htmlFor: `selection for ${o}`, children: o }),
    /* @__PURE__ */ e.jsx(M, { align: "center", id: `selection for ${o}`, gap: "10px", direction: "row", children: a == null ? void 0 : a.split(",").map((x) => {
      const g = h === x;
      return /* @__PURE__ */ e.jsx(
        V,
        {
          variant: g ? "solid" : "outline",
          _hover: {
            borderColor: "brand.black"
          },
          maxHeight: "50px",
          height: "50px",
          minWidth: "100px",
          onClick: () => r([x]),
          children: x
        },
        x
      );
    }) })
  ] }) : /* @__PURE__ */ e.jsxs(M, { direction: "column", py: "25px", gap: "20px", children: [
    /* @__PURE__ */ e.jsx(v, { fontSize: "large", as: "label", htmlFor: `selection for ${o}`, children: o }),
    /* @__PURE__ */ e.jsx(M, { id: `selection for ${o}`, gap: "10px", direction: "column", children: /* @__PURE__ */ e.jsx(Vt, { onChange: (x) => r(x), children: /* @__PURE__ */ e.jsx(Yt, { spacing: 3, direction: "column", children: l == null ? void 0 : l.map((x, g) => /* @__PURE__ */ e.jsx(
      Jt,
      {
        colorScheme: "blackAlpha",
        borderColor: "brand.secondary",
        _checked: {
          "& .chakra-checkbox__control": {
            background: "brand.black",
            border: "none"
          }
        },
        value: x,
        children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: x,
            translationKey: `chatnps/reason${s.toUpperCase()}${g}`
          }
        )
      },
      `${x}-reason`
    )) }) }) })
  ] });
}, an = ({
  label: o,
  questionId: i,
  formState: t,
  setUpdateFormValue: n
}) => {
  var r;
  const { chatConfig: a } = B(), { surveyCommentCharLimit: s } = (a == null ? void 0 : a.chatSurvey) ?? {}, d = ((r = t == null ? void 0 : t.find((c) => c.QuestionId === i)) == null ? void 0 : r.Answer) ?? "";
  return /* @__PURE__ */ e.jsxs(M, { direction: "column", py: "25px", gap: "10px", children: [
    /* @__PURE__ */ e.jsx(v, { fontSize: "medium", as: "label", htmlFor: `input for ${o}`, children: o }),
    /* @__PURE__ */ e.jsx(
      Ze,
      {
        placeholder: "Type your comments here...",
        maxH: "200px",
        id: `input for ${o}`,
        value: d,
        onChange: (c) => {
          s && c.target.value.length > s || n(i, c.target.value.toString());
        }
      }
    ),
    s && /* @__PURE__ */ e.jsxs(
      v,
      {
        mb: 4,
        color: d.length > s - 20 ? "red" : "#6E767D",
        fontFamily: "ApercuPro",
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "20px",
        textAlign: "right",
        children: [
          d.length,
          " / ",
          s.toString()
        ]
      }
    )
  ] });
}, cn = (o) => o > 8 ? "Extremely Likely" : o > 6 ? "Likely" : o > 4 ? "Neutral" : o > 2 ? "Unlikely" : "Not likely at all", ln = ({
  label: o,
  questionId: i,
  formState: t,
  setUpdateFormValue: n,
  steps: a,
  questionType: s,
  npsValue: d,
  setNpsValue: r
}) => {
  var C, w;
  const { data: c } = N(), { theme: l } = c, {
    components: { chat: h }
  } = l, { chatConfig: u } = B(), x = [...Array(a).keys()].map((I) => I + 1), g = (C = t == null ? void 0 : t.find((I) => I.QuestionId === i)) == null ? void 0 : C.Answer, m = s === "NPS", p = ((w = u == null ? void 0 : u.chatSurvey) == null ? void 0 : w.defaultSliderValue) ?? 1;
  return ee(() => {
    g || (n(i, p.toString()), m && r(p));
  }, []), /* @__PURE__ */ e.jsxs(M, { direction: "column", my: "30px", children: [
    /* @__PURE__ */ e.jsx(v, { as: "label", fontWeight: "normal", htmlFor: `slider for ${o}`, children: o }),
    /* @__PURE__ */ e.jsxs(M, { p: "10px", direction: "column", children: [
      /* @__PURE__ */ e.jsx(M, { w: "full", justifyContent: "center", minHeight: "40px", children: m && /* @__PURE__ */ e.jsx(se, { fontSize: "lg", fontWeight: "bold", pt: "10px", children: /* @__PURE__ */ e.jsx(
        f,
        {
          text: cn(d),
          translationKey: `chatnps/npsValue-${d}`
        }
      ) }) }),
      /* @__PURE__ */ e.jsxs(
        Xt,
        {
          defaultValue: p,
          id: `slider for ${o}`,
          min: 1,
          max: a,
          step: 1,
          mt: "40px",
          onChange: (I) => {
            n(i, I.toString()), m && r(I);
          },
          children: [
            x.map((I) => {
              const y = parseInt(g ?? p.toString()) === I;
              return /* @__PURE__ */ e.jsx(
                Zt,
                {
                  value: I,
                  textAlign: "start",
                  fontSize: y ? "xl" : "sm",
                  color: y ? h.onPrimary : "",
                  top: y ? "1" : "",
                  mt: "-10",
                  w: "12",
                  ml: "-4px",
                  children: I
                },
                I
              );
            }),
            /* @__PURE__ */ e.jsx(eo, { bg: h.onPrimary, h: "8px", borderRadius: 8, children: /* @__PURE__ */ e.jsx(to, { bg: h.primary }) }),
            /* @__PURE__ */ e.jsx(
              oo,
              {
                boxSize: 5,
                bg: h.primary,
                boxShadow: "rgba(0, 0, 0, 0.15) 2px 2px 1px"
              }
            )
          ]
        }
      )
    ] })
  ] });
}, dn = {
  slider: ln,
  option: rn,
  comment: an
}, un = () => {
  var g;
  const {
    groupedQuestions: o,
    isSurveyDataLoading: i,
    isSurveyFetchErrored: t,
    isLastPage: n,
    isFormSubmitted: a,
    isSubmitDisabled: s,
    page: d,
    npsValue: r,
    formState: c,
    handleNavigationClick: l,
    updateFormValue: h,
    setNpsValue: u
  } = nn(), x = re(() => a ? /* @__PURE__ */ e.jsx(f, { text: "Close", translationKey: "Global/chatNPSCloseButtonText" }) : n ? /* @__PURE__ */ e.jsx(f, { text: "Submit", translationKey: "Global/chatNPSSubmitButtonText" }) : /* @__PURE__ */ e.jsx(f, { text: "Next", translationKey: "Global/chatNPSSubmitButtonText" }), [a, n]);
  return i ? /* @__PURE__ */ e.jsx(se, { h: "full", children: /* @__PURE__ */ e.jsx(et, {}) }) : t || !o.length ? /* @__PURE__ */ e.jsxs(M, { direction: "column", gap: "10px", h: "full", py: "20%", px: 4, overflowY: "auto", children: [
    /* @__PURE__ */ e.jsx(
      v,
      {
        align: "center",
        fontSize: "3xl",
        fontWeight: "light",
        letterSpacing: "-0.352px",
        lineHeight: "39.68px",
        children: /* @__PURE__ */ e.jsx(
          f,
          {
            text: "Oops...",
            translationKey: "Global/chatNPSErrorEndFeedbackHeader"
          }
        )
      }
    ),
    /* @__PURE__ */ e.jsx(v, { fontSize: "xl", align: "center", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
      f,
      {
        text: "Something went wrong. We are looking into it.",
        translationKey: "Global/chatNPSErrorEndFeedbackDescription"
      }
    ) })
  ] }) : /* @__PURE__ */ e.jsxs(
    M,
    {
      direction: "column",
      p: "20px",
      h: "full",
      w: "full",
      justifyContent: "space-between",
      overflowY: "auto",
      overflowX: "hidden",
      children: [
        a ? /* @__PURE__ */ e.jsx(sn, {}) : /* @__PURE__ */ e.jsxs(M, { direction: "column", children: [
          d === 0 && /* @__PURE__ */ e.jsx(v, { fontSize: "xx-large", lineHeight: "45px", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
            f,
            {
              text: "Your feedback is important to us",
              translationKey: "Global/chatNPSGreetingText"
            }
          ) }),
          (g = o == null ? void 0 : o[d]) == null ? void 0 : g.map((m) => {
            const p = dn[m.QuestionOptions];
            return p ? /* @__PURE__ */ e.jsx(
              p,
              {
                questionId: m.QuestionId,
                label: m.QuestionDescription,
                formState: c,
                setUpdateFormValue: h,
                steps: m.QuestionType === "NPS" ? 10 : 5,
                questionType: m.QuestionType,
                npsValue: r,
                setNpsValue: u,
                optionString: m.AnswerOptions
              },
              m.QuestionId
            ) : `Error: Component for questionType "${m.QuestionOptions}" not found.`;
          })
        ] }),
        /* @__PURE__ */ e.jsx(
          V,
          {
            justifySelf: "flex-end",
            isDisabled: s,
            onClick: l,
            children: x
          }
        )
      ]
    }
  );
}, hn = () => {
  const { isTimeoutWarningVisible: o, isTimedOut: i, count: t } = Re(), { isChatConnecting: n, isChatEnded: a, isChatbotEnded: s, isSurveyVisible: d, setShowIdleMessage: r } = _(), { handleEndChatSession: c } = oe(), l = !n && !a && !s, h = !n && s && a && !d;
  return je.useEffect(() => {
    o ? r(!0) : i && c();
  }, [t]), /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", align: "center", w: "full", h: "full", children: [
    /* @__PURE__ */ e.jsx(Po, {}),
    n && /* @__PURE__ */ e.jsx(Ro, { showCancel: !0 }),
    l && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(tn, {}),
      /* @__PURE__ */ e.jsx(Lo, {})
    ] }),
    h && /* @__PURE__ */ e.jsx(Eo, {}),
    d && /* @__PURE__ */ e.jsx(un, {})
  ] });
}, pn = ({
  css: o,
  question: i,
  setQuestion: t,
  selectedDevice: n,
  deviceList: a
}) => {
  const { isOpen: s, isMinimized: d } = ae();
  return s ? /* @__PURE__ */ e.jsx(
    M,
    {
      position: "fixed",
      w: { base: "full", lg: "350px" },
      h: { base: "full", xs: "800px" },
      mt: { base: "unset", lg: "30px" },
      top: "56px",
      bottom: { base: 0, lg: 8 },
      right: { base: 0, lg: 8 },
      zIndex: "20000",
      borderRadius: "lg",
      boxShadow: "lg",
      visibility: d ? "hidden" : "visible",
      bg: "white",
      sx: o,
      children: /* @__PURE__ */ e.jsx(To, { deviceList: a, selectedDevice: n, children: /* @__PURE__ */ e.jsx(ko, { children: /* @__PURE__ */ e.jsx(Mo, { children: /* @__PURE__ */ e.jsx(Ao, { children: /* @__PURE__ */ e.jsx(Fo, { children: /* @__PURE__ */ e.jsx(Do, { question: i, setQuestion: t, children: /* @__PURE__ */ e.jsx(hn, {}) }) }) }) }) }) })
    }
  ) : /* @__PURE__ */ e.jsx(e.Fragment, {});
}, rr = ({
  isLoggedIn: o,
  widgetStyles: i,
  windowStyles: t,
  question: n,
  setQuestion: a,
  selectedDevice: s,
  deviceList: d
}) => /* @__PURE__ */ e.jsx(vo, { isLoggedIn: o, children: /* @__PURE__ */ e.jsxs(it, { children: [
  /* @__PURE__ */ e.jsx(
    pn,
    {
      css: t,
      question: n,
      setQuestion: a,
      deviceList: d,
      selectedDevice: s
    }
  ),
  /* @__PURE__ */ e.jsx(ct, { ...i })
] }) }), xn = [
  "en-US",
  "zh-Hant-TW",
  "en-HK",
  "en-NZ",
  "ko-KR",
  "ms-MY",
  "th-TH"
], gn = ({
  setCollapsed: o,
  collapsed: i,
  isMobile: t
}) => {
  const [n, a] = q("en-US"), [s, d] = q([]), r = () => {
    o(!i);
  }, { translationComponents: c } = Gt(), { updateLocaleLanguage: l, setIsTranslationsActive: h, isTranslationsActive: u, localeLanguage: x } = zt();
  return ee(() => {
    d(c);
  }, []), ee(() => {
    a(x), d(c);
  }, [x, i, n]), /* @__PURE__ */ e.jsxs(
    k,
    {
      width: t ? "full" : "400px",
      height: "100vh",
      backgroundColor: "#f1f1f1",
      pos: "fixed",
      top: "0",
      right: i ? "0" : t ? "100%" : "-400px",
      transition: "left 0.5s ease-in-out",
      zIndex: "10",
      p: "6",
      py: "14",
      overflowY: "scroll",
      children: [
        /* @__PURE__ */ e.jsx(
          no,
          {
            "aria-label": "Toggle Sidebar",
            icon: i ? /* @__PURE__ */ e.jsx(tt, {}) : /* @__PURE__ */ e.jsx(io, {}),
            onClick: r,
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            zIndex: "20"
          }
        ),
        /* @__PURE__ */ e.jsxs(
          Ie,
          {
            display: "flex",
            flexFlow: "column nowrap",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            children: [
              /* @__PURE__ */ e.jsx(v, { as: "h2", fontSize: "xl", fontWeight: "bold", children: "Translations" }),
              /* @__PURE__ */ e.jsx(v, { children: "Supported locales:" }),
              /* @__PURE__ */ e.jsxs(V, { onClick: () => h(!u), children: [
                "Toggle Translation: Currently ",
                u ? "on" : "off"
              ] }),
              /* @__PURE__ */ e.jsx(k, { display: "flex", flexFlow: "row wrap", gap: "2", children: xn.map((g, m) => /* @__PURE__ */ e.jsx(
                V,
                {
                  border: "1px solid #ccc",
                  p: "2",
                  onClick: () => {
                    l(g), a(g);
                  },
                  style: n === g ? { background: "rgb(130, 35, 210)", color: "white" } : { background: "black", color: "white" },
                  children: g
                },
                `${g}-${m}`
              )) }),
              /* @__PURE__ */ e.jsx(k, { as: "ul", display: "flex", flexFlow: "column nowrap", gap: "2", w: "full", children: s.sort((g, m) => g.i - m.i).filter((g) => g.s === "active").map((g, m) => /* @__PURE__ */ e.jsxs(
                k,
                {
                  as: "li",
                  style: { listStyle: "none" },
                  boxShadow: "md",
                  borderRadius: "base",
                  py: "4",
                  px: "4",
                  w: "full",
                  children: [
                    /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", children: [
                      /* @__PURE__ */ e.jsx(v, { as: "h3", fontSize: "md", fontWeight: "bold", children: "Text:" }),
                      /* @__PURE__ */ e.jsx(v, { as: "p", children: g.text })
                    ] }),
                    /* @__PURE__ */ e.jsx(k, { mt: "2", children: /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", gap: "2", children: [
                      /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", children: [
                        /* @__PURE__ */ e.jsx(v, { as: "h4", fontSize: "md", fontWeight: "bold", children: "Module:" }),
                        /* @__PURE__ */ e.jsx(v, { as: "p", fontSize: "md", children: g.meta.module })
                      ] }),
                      /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", children: [
                        /* @__PURE__ */ e.jsx(v, { as: "h4", fontSize: "md", fontWeight: "bold", children: "Section:" }),
                        /* @__PURE__ */ e.jsx(v, { as: "p", fontSize: "md", children: g.meta.section })
                      ] }),
                      /* @__PURE__ */ e.jsxs(M, { flexFlow: "column nowrap", children: [
                        /* @__PURE__ */ e.jsx(v, { as: "h4", fontSize: "md", fontWeight: "bold", children: "Path/id:" }),
                        /* @__PURE__ */ e.jsx(v, { as: "p", fontSize: "md", children: g.meta.path })
                      ] })
                    ] }) })
                  ]
                },
                m + g.meta.path
              )) })
            ]
          }
        )
      ]
    }
  );
}, mn = {}, ar = ({
  env: o,
  module: i,
  children: t
}) => {
  var j;
  const [n, a] = q("en-US"), [s, d] = q([]), [r, c] = q(i), [l, h] = q(
    (o && ((j = o == null ? void 0 : o.disabled) == null ? void 0 : j.toString()) !== "true") ?? !0
  ), [u] = We({
    authorization: "",
    token: ""
  }), x = yo(() => Kt(mn, o == null ? void 0 : o.url));
  ee(() => {
    l && g(n);
  }, [r, n, l]);
  const g = async (S) => {
    try {
      if (!r)
        throw "No local module";
      const T = await Bt(x, S, r);
      if (T === null)
        throw "No strings data fetched";
      d(T.body);
    } catch {
      d([]);
    }
  }, m = (S, T) => {
    let L = "", U = "";
    for (const A of s)
      if (A.id === T)
        for (const F of A.text)
          F.path === S && (L = F.text, U = F.internalId);
      else
        break;
    return { textEntry: L, entryId: U };
  }, p = async (S, T, L) => {
    try {
      if (!m(S, T))
        throw "No entry found";
      const A = await $t(x, u, S, L, n);
      console.log(A);
    } catch (U) {
      throw console.log(U), U;
    }
  }, [C, w] = q(!1), [I] = so("(min-width: 800px)");
  return o && o.disabled === "true" || o && o.disabled === !0 ? /* @__PURE__ */ e.jsx(e.Fragment, { children: t }) : /* @__PURE__ */ e.jsx(
    Ut.Provider,
    {
      value: {
        entries: s,
        updateEntry: p,
        updateLocaleLanguage: a,
        localeLanguage: n,
        getTextEntry: m,
        localModule: r,
        setLocalModule: c,
        isTranslationsActive: l,
        setIsTranslationsActive: h,
        translationAPI: {
          api: x,
          authorization: u.authorization,
          token: u.token
        }
      },
      children: /* @__PURE__ */ e.jsx(Ht, { children: /* @__PURE__ */ e.jsxs(M, { flexFlow: "row nowrap", children: [
        /* @__PURE__ */ e.jsx(k, { as: "div", id: "translation-ctx", w: "full", flex: "1", children: t }),
        /* @__PURE__ */ e.jsx(
          gn,
          {
            setCollapsed: w,
            collapsed: C,
            isMobile: !I
          }
        )
      ] }) })
    }
  );
};
export {
  za as AddCard,
  Br as AvatarInitials,
  $r as BackButton,
  Ba as BillingDetails,
  Aa as Button,
  lr as CSAT,
  ma as Cards,
  Ua as ChangeAddress,
  dr as Chat,
  Ac as ChatButton,
  di as CloudIcon,
  ui as CogIcon,
  ti as CognitoAuthProvider,
  ur as ConfirmDeviceRegistration,
  hr as ConfirmationAfterSubmission,
  pr as CreatePasswordSchema,
  Ha as Creditcard,
  xr as CustomerSupportFooter,
  Ia as DeliveryDetails,
  wa as DeliveryOptions,
  gr as DesktopView,
  ea as DeviceCard,
  Fa as DeviceModel,
  aa as DeviceService,
  Sa as DeviceSpecification,
  Xr as Faq,
  Tc as FeatureProvider,
  si as GoogleSignInButton,
  mr as Header,
  oa as HelloWorld,
  Ka as ImeiConfirmation,
  $a as ImeiDetails,
  Vr as Input,
  br as LanguageSelector,
  hi as LockIcon,
  va as LogisticsAndFulfilment,
  fr as MenuButton,
  yr as MenuDisplay,
  Fc as Mixpanel,
  Sr as MobileView,
  rr as MyAsurionChat,
  Nc as MyAsurionDevTools,
  Cr as MyAsurionProvider,
  _a as MyPayments,
  wr as NPS,
  Wa as NPSReasons,
  La as NPSSlider,
  jr as NewAddress,
  ri as OTPInput,
  Ir as PASSWORDFORM,
  vr as PasswordResetForm,
  Tr as PasswordResetSchema,
  gi as PaymentCCIcon,
  ha as PaymentForm,
  Ta as PickupSchedule,
  pi as ProfileIcon,
  Hr as ProtectedLayout,
  kr as RemoteConfig,
  Mr as Renewal,
  Ar as RenewalConfirmation,
  da as ReviewSubmission,
  Qa as ReviewUpdateDevice,
  Va as SelectCapacity,
  Ya as SelectColor,
  qr as SignOutLink,
  fa as SmartStock,
  ka as StoreSelection,
  _r as SubHeader,
  Ra as SubmitDeclaration,
  ai as SubmitEnquiry,
  ca as SubmitRequest,
  xa as TermsAndCondition,
  ci as TextEditIcon,
  Yr as TextInput,
  f as TextScript,
  Fr as TextScriptProvider,
  f as TextString,
  sa as TextTranslation,
  bi as ThemeProvider,
  ar as TranslationProvider,
  Pa as TriageQuestion,
  Ja as UpdateDevice,
  Dr as VideoDeclaration,
  Rr as VideoPlayer,
  Za as ViewDocument,
  Si as generateAuthorization,
  Ci as generateMixpanelId,
  wi as generateTokenTimestamp,
  ji as generateUrl,
  Ii as getAuthTokens,
  me as getCarrierByDomain,
  Gc as getChakraColorScale,
  lc as getClientConfigByDomain,
  zc as getColorsList,
  Rc as getCompleteContentfulEntry,
  dc as getConfigNameByDomain,
  Ec as getContentfulEntry,
  Pc as getContentfulImage,
  jc as getCountryByCarrier,
  Ic as getDefaultLanguageByCarrier,
  uc as getEnvByDomain,
  vi as getFirebaseConfigValue,
  Ti as getFirebaseRemoteConfig,
  hc as getHasRetailerByDomain,
  ki as getHomeLink,
  pc as getPartnerIdByDomain,
  xc as getRedirectToPortal,
  gc as getRetailerFileFolderNameByDomain,
  mc as getRetailerNameByDomain,
  bc as getSharedTypesByDomain,
  Er as getTextScript,
  fc as getTypeByDomain,
  yc as getUrlByTypeAndEnv,
  Sc as hasPartnerIdByDomain,
  Mi as hashFn,
  Bc as hexToNumber,
  Cc as isAuthPortalMerged,
  Ai as isAuthenticated,
  Uc as isValidHex,
  qi as noop,
  Fi as parseHttpPath,
  Di as parseJSON,
  Ri as printVersion,
  Oc as processContentfulImageToProgressiveJpg,
  Pe as processContentfulImageToWebp,
  fi as queryClient,
  Ei as timeConvert24to12Hr,
  Ne as useAccount,
  Oi as useAgreementData,
  We as useAuthToken,
  B as useChatConfig,
  Li as useCognitoAuth,
  oi as useCognitoAuthProvider,
  N as useConfig,
  Ni as useContentfulEntry,
  Ve as useContentfulImage,
  Wi as useDarkMode,
  Gi as useDetermineIncidentData,
  zi as useDocumentTitle,
  Bi as useElementSize,
  kc as useFeature,
  Pr as useFeatureIsOn,
  sc as useFetchConfig,
  Or as useHeader,
  Ui as useImageOnLoad,
  Hi as useInitializeData,
  Ki as useInteractionData,
  $i as useIntersectionObserver,
  _i as useInterval,
  Lr as useIsDisabledFeature,
  Qi as useIsFirstRender,
  Vi as useIsMounted,
  Yi as useLocalStorage,
  Ji as useMediaQuery,
  Nr as useNotifications,
  ac as usePublish,
  Xi as useReadLocalStorage,
  Zi as useScreen,
  Wr as useScrollBlock,
  Ue as useSessionStorage,
  Gr as useSlots,
  ic as useSubscribe,
  he as useTextScript,
  zt as useTextTranslation,
  ec as useTimeout,
  tc as useToggle,
  oc as useWindowSize
};
